// cspell:disable
// Use backticks instead of quotes to avoid having to escape apostrophes and quotes in the strings
/* oxlint quotes: ["error", "backtick"] */
export const Strings = {
    ACCOUNT: ``,
    ACCOUNT_PROFILE: `账户资料`,
    ACCOUNT_CREATED: ``,
    ACCOUNT_VERIFIED: ``,
    LOG_IN_TO_START_ORDERING: ``,
    ORDERS: ``,
    PROFILE: ``,
    PROFILE_UPDATED: ``,
    PAYMENT_METHODS: ``,
    PERSONAL_DETAILS: ``,
    SAVE_CHANGES: ``,
    ADD_CARD: ``,
    CARD_NICKNAME: ``,
    NO_SAVED_CARDS: ``,
    QR_CODE: ``,
    REFRESH_QR_CODE: ``,
    QR_CODE_SCAN_TO_PAY: ``,
    ADA_TOGGLE_ON: `点击启用缩减屏幕高度`,
    ADA_TOGGLE_OFF: `点击禁用缩减屏幕高度`,
    ADD: `添加`,
    ADD_DONATION: `添加捐款`,
    ADD_FUNDS: `在此添加资金`,
    ADD_TIP: `添加小费`,
    ADD_TO_FAVORITES_WEB: ``,
    ADD_TO_ORDER: `添加到订单`,
    ADD_NEW: `添加新项目`,
    ADDED: `已添加`,
    ADDED_TO_FAVORITES_WEB: ``,
    ADDED_TO_ORDER: `已添加到订单`,
    ADDON_TEXTFIELD_PLACEHOLDER: `请输入您的选择。`,
    ADDRESS_CITY: `城市`,
    ADDRESS_LINE_1: `街道地址`,
    ADDRESS_LINE_2: `公寓、楼层、套房、楼栋、公司（可选）`,
    ADDRESS_POSTAL_CODE: `邮政编码`,
    ALCOHOL_VERIFICATION: `酒精验证`,
    ALREADY_HAVE_AN_ACCOUNT: ``,
    ALSO_CONSIDER: `您可能也会喜欢...`,
    APPLIED_STORED_VALUE_CARDS: `礼品卡`,
    ASAP: `尽快`,
    AT_LEAST_X: `至少 {{$1: number}}`,
    BACK: `返回`,
    BACK_TO_MENU: `返回菜单`,
    BACK_TO_MENU_FROM_LOYALTY: `返回菜单`,
    BACK_TO_CART: `返回购物车`,
    BACK_TO_PAYMENT_OPTIONS: `返回支付选项`,
    BACK_TO_PAYMENT_OPTIONS_FROM_LOYALTY: `返回支付选项`,
    BAD_ACCESS_CODE: `访问码错误`,
    BALANCE: `余额`,
    BAG_OPT_IN_PROMPT: `您是否需要为您的订单添加一个外带袋？`,
    BAG_OPT_IN_TITLE: `添加袋子？`,
    BAG_OPT_IN: `是的，我需要一个袋子`,
    BAG_OPT_OUT: `不，谢谢`,
    BLOCKED_WORD_WARNING: `请删除被屏蔽的词语`,
    CALORIES: `卡路里`,
    CANCEL: `取消`,
    CANCEL_CHECKOUT: `取消`,
    CASH: `收银员`,
    CARD_ENTRY_APM: `APM`,
    CARD_ENTRY_APPLE_PAY: `Apple Pay`,
    CARD_ENTRY_CARD_ON_FILE: `已存档卡`,
    CARD_ENTRY_CHIP: `EMV`,
    CARD_ENTRY_CONTACTLESS: `非接触式`,
    CARD_ENTRY_GOOGLE_PAY: `Google Pay`,
    CARD_ENTRY_MANUALLY_ENTERED: `手动输入`,
    CARD_ENTRY_PROVIDED_EXTERNALLY: `外部提供`,
    CARD_ENTRY_SCAN: `扫描`,
    CARD_ENTRY_SWIPE: `刷卡`,
    CARD_ENTRY_UNKNOWN: `未知`,
    CARD_EXPIRED: `卡已过期`,
    CARD_EXPIRING: `您的卡即将过期`,
    CARD_ENDING_IN: ``,
    CARD_EXPIRES_ON: ``,
    CARD_EXPIRES_THIS_MONTH: ``,
    CARD_EXPIRED_LABEL: ``,
    REMOVE_SAVED_CARD_DESCRIPTION: ``,
    CARD_RENAMED: ``,
    REMOVE_SAVED_CARD: ``,
    REMOVE_SAVED_CARD_TITLE: ``,
    RENAME_CARD: ``,
    SHOW_QR_CODE: ``,
    CART: `购物车`,
    CART_LABEL: `前往购物车，共 {{$1: number}} 件商品，合计 {{$2: price}}`,
    CART_TITLE: ``,
    CHANGE_ITEM: `更换商品`,
    CHANGE_PASSWORD: `更改密码`,
    CHANGE_PASSWORD_SUCCESS: `您的密码已更新。`,
    CHARS_LEFT: `剩余 {{$1: number}} 个字符`,
    CHECK_AMOUNT: `正在验证金额...`,
    CHECKOUT: `结账`,
    CHECKOUT_STEP_CART: `购物车`,
    CHECKOUT_STEP_PAYMENT_OPTIONS: `支付`,
    CHECKOUT_STEP_PAYING: `正在支付`,
    CHECKOUT_STEP_DONE: `完成`,
    CHECKOUT_WITH_FORCED_MENU: `您无法结账，因为此网站仅为菜单预览。`,
    CHECK_YOUR_EMAIL: ``,
    CHOOSE_OPTION: `请选择一个选项`,
    CHOOSE_TIME_SLOT: `请选择时间段：`,
    CLEAR_ALL: `全部清除`,
    CLEARING_SESSION: `正在为下一位顾客准备自助机...`,
    CLOSE: `关闭`,
    CLOSED_SCREEN_MESSAGE: `抱歉，我们已关闭或暂不接受手机订单。`,
    CONFIRM: `确认`,
    CONFIRM_ADDRESS: `确认地址`,
    CONFIRM_DISCARD: `放弃此商品？`,
    CONFIRM_DISCARD_CHANGES: `确定要放弃更改吗？`,
    CONFIRM_YOUR_ITEM: `确认您的商品`,
    CONFIRM_QUIT: `确定要退出吗？`,
    CONFIRM_REFUND_AMOUNT: `确定要退款 {{$1: dollar amount}} 吗？`,
    CONFIRMING_YOUR_CARD: `正在确认您的卡...`,
    CONTINUE: `继续`,
    CONTINUE_AS_GUEST: `以访客身份继续`,
    COULD_WE_INTEREST: `您可能感兴趣...`,
    COMP_CARD: `优待卡`,
    COMP_CARD_SCAN: `扫描优待卡`,
    COMP_CARD_SCAN_FAILED_TITLE: `优待卡扫描失败`,
    COMP_CARD_SCAN_FAILED_MESSAGE: `扫描优待卡时出错。请重试。`,
    COMP_CARD_APPLYING_TITLE: `正在应用优待卡`,
    COMP_CARD_APPLYING_ERROR_TITLE: `优待卡应用错误`,
    COMP_CARD_APPLYING_ERROR_MESSAGE: `应用优待卡时出错。请重试。`,
    COMP_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `请输入优待卡号码`,
    COMP_CARD_ENTERING_NUMBER_ERROR_INVALID: `请输入有效的优待卡号码`,
    COMP_CARD_ENTERING_NUMBER_ERROR_LENGTH: `请输入有效的优待卡号码`,
    COMP_CARD_ENTERING_PIN_ERROR_REQUIRED: `请输入优待卡PIN码`,
    COMP_CARD_ENTERING_PIN_ERROR_INVALID: `请输入有效的优待卡PIN码`,
    COMP_CARD_ENTERING_PIN_ERROR_LENGTH: `请输入有效的优待卡PIN码`,
    COMP_CARD_ENTERING_NUMBER_HINT: `请输入优待卡号码。号码长度为 {{$1: number}} 位。`,
    COMP_CARD_ENTERING_PIN_HINT: `请输入优待卡PIN码。号码长度为 {{$1: length}} 位。`,
    COMP_CARD_ERROR_REMOVING: `删除优待卡时出错。请重试。`,
    'bottom-bar.storm-toggle.on': `点击启用Storm导航`,
    'bottom-bar.storm-toggle.off': `点击禁用Storm导航`,
    'campus-card.label': `校园卡`,
    'campus-card.payment-line-label': ``,
    'campus-card.payment-option-label': `点击使用校园卡支付`,
    'campus-card.scan': `扫描您的校园卡`,
    'campus-card.scan-failed.title': `校园卡扫描失败`,
    'campus-card.scan-failed.message': `扫描校园卡时出错。请重试。`,
    'campus-card.enter-number': `输入您的校园卡号码`,
    'campus-card.enter-pin': `输入您的校园卡PIN码`,
    'campus-card.applying.title': `正在应用校园卡`,
    'campus-card.applying.error.title': `校园卡应用错误`,
    'campus-card.applying.error.message': `应用校园卡时出错。请重试。`,
    'campus-card.entering-number.error.required': `请输入校园卡号码`,
    'campus-card.entering-number.error.invalid': `请输入有效的校园卡号码`,
    'campus-card.entering-number.error.length': `请输入有效的校园卡号码`,
    'campus-card.entering-number.hint': `请输入您的校园卡号码。号码长度为 {{$1: number}} 位。`,
    'campus-card.entering-pin.error.required': `请输入校园卡PIN码`,
    'campus-card.entering-pin.error.invalid': `请输入有效的校园卡PIN码`,
    'campus-card.entering-pin.error.length': `请输入有效的校园卡PIN码`,
    'campus-card.entering-pin.hint': `请输入校园卡PIN码。号码长度为 {{$1: length}} 位。`,
    'campus-card.error-removing': `删除校园卡时出错。请重试。`,
    'campus-card.no-balance.title': `无可用余额`,
    'campus-card.no-balance.message': `此校园卡无可用余额。`,
    'campus-card.add-another': `添加另一张`,
    'campus-card.remove': `删除校园卡`,
    'campus-card.select-account.title': `选择账户`,
    'campus-card.select-account.loading': `正在加载账户...`,
    'campus-card.select-account.error.title': `无法加载账户`,
    'campus-card.select-account.error.message': `无法加载您的账户。请重试。`,
    'campus-card.select-account.column.account': `账户`,
    'campus-card.select-account.column.balance': `当前余额`,
    'campus-card.select-account.error.toast-title': `错误`,
    'campus-card.select-account.error.toast-message': `验证失败。请重试。`,
    'campus-card.swipe': `刷校园卡支付`,
    COUPON: `优惠券`,
    COUPON_ALREADY_USED: `优惠券码已使用。`,
    COUPON_MIN_SPEND_NOT_MET: `您输入的优惠券码不满足最低消费要求。`,
    COUPON_NOT_FOUND: `未找到优惠券码。`,
    COUPON_NOT_ACCEPTED: `您输入的优惠券码未被接受。`,
    COUPON_APPLYING: `正在应用优惠券`,
    COUPON_APPLYING_ERROR_TITLE: `优惠券应用错误`,
    COUPON_APPLYING_ERROR_MESSAGE: `应用优惠券时出错。请重试。`,
    COUPON_ORDER_REQUIREMENTS_NOT_MET: `您输入的优惠券码不满足订单要求。`,
    COUPON_SCANNING_ERROR_TITLE: `优惠券扫描错误`,
    COUPON_SCANNING_ERROR_MESSAGE: `扫描优惠券时出错。请重试。`,
    COUPON_ENTERING_ERROR_LENGTH: `请输入优惠券码。`,
    COUPON_ENTERING_ERROR_INVALID: `请输入有效的优惠券码。`,
    COUPON_ERROR_REMOVING: `删除优惠券时出错。请重试。如问题持续，请联系工作人员。`,
    CREATE_A_NEW_ACCOUNT: `创建新账户`,
    CREATE_ACCOUNT: `创建账户`,
    CREATE_ACCOUNT_TERMS_LINE: `创建账户即表示您同意`,
    CREDIT_CARD: `信用卡`,
    CREDIT_CARD_NUMBER: `卡号`,
    CURBSIDE: `路边取餐`,
    CURRENT_PASSWORD: `当前密码`,
    CUSTOM_TIP: `自定义`,
    CUSTOM_TIP_INVALID: `请输入有效的小费金额。`,
    CUSTOM_TIP_HINT: `输入您的小费金额。最高：{{$1: number}}`,
    CUSTOM_DONATION: `自定义捐款`,
    CUSTOMER_CARDS: `使用已保存的卡`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN: `登录`,
    CUSTOMER_ACCOUNT_BUTTON_LOG_IN_TOP_BAR: ``,
    CUSTOMER_ACCOUNT_BUTTON_LOGGED_IN: `我的账户`,
    CUSTOMIZE: `自定义`,
    DEBIT: `借记`,
    DEBIT_CREDIT_CARD: `借记/信用卡`,
    DEMO_PAY: `演示：支付`,
    DELIVERY: `外卖配送`,
    DELIVERY_ADDRESS: `配送地址`,
    DELIVERY_INSTRUCTIONS: ``,
    DESELECTED_MOD_PREFIX: `移除 {{$1: mod name}}`,
    DINE_IN: `堂食`,
    DISCLAIMER_EMAIL: `使用电子邮件地址须遵守服务条款。`,
    DISCLAIMER_PHONE: `使用电话号码须遵守服务条款。`,
    DISCLAIMER_PHONE_LINK: `服务条款：`,
    DISCLAIMER_PHONE_DESCRIPTION: `关于电话号码的使用`,
    DISCLAIMER_NAME: `您的姓名将用于确认订单并方便在指定区域取餐。`,
    DISCOUNTS: `折扣`,
    DISCOUNTS_WILL_BE_APPLIED_AT_CHECKOUT: `折扣将在结账时应用`,
    DISCOUNT_WILL_BE_APPLIED_AT_CHECKOUT: `折扣将在结账时应用`,
    DONATION: `捐款`,
    DONATION_APPLYING: `正在处理捐款...`,
    DONATION_APPLY_ERROR_TITLE: `捐款处理错误`,
    DONATION_APPLY_ERROR_MESSAGE: `处理您的捐款时出错。请重试。`,
    DONATION_FAILED: `捐款失败。请重试。`,
    DONATION_ROUND_UP_TITLE: `是否将总金额四舍五入？`,
    DONATION_ROUND_UP_TO: `四舍五入至 {{$1: amount}}`,
    DONATION_ROUND_UP_SUBTITLE: `是否将总金额四舍五入至最近的整元？`,
    DONATION_ROUND_UP_ACCEPT: `是，四舍五入`,
    DONATION_ROUND_UP_REJECT: `不，谢谢`,
    DONATION_REMOVE: `删除捐款`,
    DONE: `完成`,
    DONT_INCLUDE_UTENSILS: `不需要餐具`,
    EBT: `SNAP EBT`,
    EBT_REFUND: `EBT退款`,
    EBT_CHOICE_DIALOG_TITLE: `您希望使用哪种EBT方式？`,
    EBT_CHOICE_CASH_BENEFIT: `现金福利`,
    EBT_CHOICE_FOOD_STAMPS: `食品券`,
    EBT_CARD_SUBTITLE: `在刷卡机上刷您的EBT卡`,
    EDIT: `编辑`,
    EDIT_ORDER: `编辑订单`,
    EDIT_TIP: `编辑小费`,
    SAVE_ORDER: `保存订单`,
    SAVE_BUTTON: ``,
    EMAIL_ADDRESS: `电子邮件地址`,
    EMAIL_RECEIPT: `电子邮件收据`,
    EMAIL_REQUIRED_FOR_RECEIPT: `需要提供电子邮件以获取收据。`,
    EMAIL_RECEIPT_SEND_FAILED: `无法发送收据。请重试。`,
    EMAIL_RECEIPT_SEND_SUCCESS: `收据发送成功。`,
    ENTER_ACCESS_CODE: `输入访问码：`,
    ENTER_EMAIL_CUSTOMER_IDENTIFIER: `输入您的电子邮件`,
    ENTER_GIFT_CARD_BARCODE_FALLBACK: `无法扫描？请输入您的卡号。`,
    ENTER_PHONE_CONSENT: `我同意通过短信接收营销材料。`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER: `输入您的电话号码`,
    ENTER_PHONE_CUSTOMER_IDENTIFIER_WITH_NAME: `您好 {{$1 guest name}}，请输入您的电话号码`,
    ENTER_PHONE_LOYALTY: `输入您的手机号码`,
    ENTER_PHONE_RECEIPT: `输入您的手机号码以接收收据`,
    ENTER_PHONE_TEXT_WHEN_READY: `输入您的电话号码，订单准备好后我们将发送短信通知！`,
    ENTER_VEHICLE_DESCRIPTION: `请输入您的车辆信息，以便我们为您送餐：`,
    ENTER_YOUR_COUPON_CODE: `输入您的优惠券码`,
    ENTER_YOUR_COMP_CARD_NUMBER: `输入您的优待卡号码`,
    ENTER_YOUR_COMP_CARD_PIN: `输入您的优待卡PIN码`,
    ENTER_YOUR_GIFT_CARD_NUMBER: `输入您的礼品卡号码`,
    ENTER_YOUR_GIFT_CARD_PIN: `输入您的礼品卡PIN码`,
    ENTER_YOUR_EMAIL: `输入您的电子邮件：`,
    ENTER_YOUR_EMAIL_VALIDATION_FAILED: `电子邮件无效。请重试。`,
    ENTER_YOUR_FIRST_NAME: `输入您的名字：`,
    ENTER_YOUR_LAST_NAME: `输入您的姓氏首字母：`,
    ENTER_YOUR_NAME: `输入您的姓名：`,
    ENTER_YOUR_NAME_VALIDATION_FAILED: `姓名无效。请重试。`,
    ENTER_YOUR_NAME_VALIDATION_LENGTH_FAILED: `请输入姓名。`,
    ENTER_YOUR_LAST_NAME_VALIDATION_LENGTH_FAILED: `只允许输入一个字母。请重试。`,
    ENTER_YOUR_NAME_VALIDATION_FORMAT_FAILED: `姓名只能包含字母。请重试。`,
    ENTER_YOUR_NAME_VALIDATION_PROFANITY_FAILED: `姓名包含不当词语。请重试。`,
    ERROR: `哎呀！`,
    ERROR_ADDING_ITEM: `将商品添加到购物车时出错。请重试。如问题持续，请向最近的团队成员寻求帮助。`,
    ERROR_EDITING_ITEM: `编辑购物车中的商品时出错。请重试。如问题持续，请向最近的团队成员寻求帮助。`,
    ERROR_AMOUNT_EXCEEDS_BALANCE: `金额超过卡片余额。`,
    ERROR_CARD_CONFIRMATION: `抱歉！无法确认卡片。请重试。`,
    ERROR_CARD_DECLINED: `无法扣款。请重试。`,
    ERROR_CARD_INACTIVE: `抱歉，此学生卡未激活。`,
    ERROR_CARD_NOT_FOUND: `抱歉！未找到此卡片。请重试。`,
    ERROR_CARD_NUMBER_LENGTH: `卡号长度不正确。`,
    ERROR_CARD_RESTRICTED_TIME: `抱歉，此卡目前无法使用。`,
    ERROR_CARD_SCHEME_NOT_ACCEPTED: `抱歉，此处不接受 {{$1: cardScheme}}。请尝试其他卡片。`,
    ERROR_COUPON_CONFIRMATION: `抱歉！无法使用优惠券码。请重试。`,
    ERROR_INVALID_EMAIL: `电子邮件地址无效`,
    ERROR_INVALID_LOGIN_CREDS: `用户名或密码无效`,
    ERROR_INVALID_NAME: `请输入有效姓名`,
    ERROR_INVALID_PHONE_NUMBER: `请输入有效电话号码`,
    ERROR_INVALID_ROOM_NUMBER: `请输入有效房间号`,
    ERROR_INVALID_TABLE_NUMBER: `请输入有效桌号`,
    ERROR_INVALID_VERIFICATION_CODE: `验证码无效`,
    ERROR_KIOSK_CARD_DECLINED: `出现问题。您的卡片未被扣款。请重试。`,
    ERROR_KIOSK_CARD_DECLINED_TAP: `无法读取卡片。请重试。`,
    ERROR_KIOSK_PAYMENT_DEVICE_NOT_FOUND: `自助机无法找到支付设备。您的卡片未被扣款。请联系工作人员。`,
    ERROR_KIOSK_PAYMENT_DEVICE_OFFLINE: `支付设备似乎离线。您的卡片未被扣款。请联系工作人员。`,
    ERROR_ORDER_OPERATION: `抱歉，无法处理您的订单。请重试。`,
    ERROR_PIN_LENGTH: `PIN码长度不正确。`,
    ERROR_RECEIVING_PAYMENT: `终端无法处理您的支付。请重试。`,
    ERROR_RECEIVING_PAYMENT_INSTRUCTIONS: `未收到付款。此订单尚未发送。您的收据将包含订单摘要。请联系工作人员获取帮助。`,
    ERROR_SENDING_ORDER: `您好，向厨房发送订单时似乎出现问题。请联系工作人员获取帮助。`,
    ERROR_SENDING_ORDER_INSTRUCTIONS: `付款成功，但向厨房发送订单时出现问题。请联系工作人员。您的收据将包含订单摘要。`,
    ERROR_STARTING_ORDER: `抱歉，无法启动您的订单。请重试。如问题持续，请联系工作人员。`,
    ERROR_UPDATING_ORDER: `抱歉，无法更新您的订单。请重试。如问题持续，请联系工作人员。`,
    ERROR_VIEWING_ITEM_ALCOHOL_LIMIT: `无法查看此商品。您已达到此订单的酒精限制。请删除一件含酒精商品后再添加此商品。`,
    ERROR_VIEWING_ITEM_SPECIAL_OFFER_LIMIT: `无法查看此商品。您已达到此订单的特价商品限制。请删除一件特价商品后再添加此商品。`,
    EXIT: `退出`,
    EXIT_CONFIRMATION: `确定要退出吗？退出将清除您的订单。`,
    EXIT_TO_COVER: ``,
    FAVORITE: `收藏`,
    FAVORITES: `我的收藏`,
    FAVORITES_NONE_YET: `暂无收藏。`,
    FAVORITES_REMOVE_CONFIRMATION: `确定要删除此收藏吗？`,
    FETCHING_RECOMMENDATIONS: `正在获取推荐...`,
    FIND_ACCOUNT: `查找账户`,
    FIRST_NAME: `名字`,
    FORGOT_PASSWORD: `忘记密码？`,
    FULFILLMENT_LABEL_ADDRESS: `地址`,
    FULFILLMENT_LABEL_GUEST_EMAIL: `电子邮件`,
    FULFILLMENT_LABEL_GUEST_NAME: `姓名`,
    FULFILLMENT_LABEL_ORDER_NUMBER: `订单号`,
    FULFILLMENT_LABEL_TABLE_NUMBER: `桌号`,
    FULFILLMENT_LABEL_PHONE_NUMBER: `电话号码`,
    FULFILLMENT_LABEL_TRACKER_NUMBER: `跟踪号`,
    FULFILLMENT_LABEL_VEHICLE_DESCRIPTION: `车辆描述`,
    FULFILLMENT_INSTRUCTION_ADDRESS: `您的订单将配送到以下地址。`,
    FULFILLMENT_INSTRUCTION_GUEST_EMAIL: `我们将向您发送收据。`,
    FULFILLMENT_INSTRUCTION_GUEST_NAME: `订单准备好后将呼叫您的姓名。`,
    FULFILLMENT_INSTRUCTION_ORDER_NUMBER: `将呼叫您的订单号。`,
    FULFILLMENT_INSTRUCTION_PHONE_NUMBER: `订单准备好后您将收到短信通知。`,
    FULFILLMENT_INSTRUCTION_TABLE_NUMBER: `您的订单将送到您的桌位。`,
    FULFILLMENT_INSTRUCTION_TRACKER_NUMBER: `订单准备好后，您的追踪器将响起。`,
    FULFILLMENT_INSTRUCTION_VEHICLE_DESCRIPTION: `您到达餐厅外后，我们将为您送出订单。`,
    FULFILLMENT_TOGGLE: `切换当前取餐方式`,
    FULL_NAME: `全名`,
    FUTURE_ORDER_MENU_FETCH_ERROR: `抱歉！无法找到该时间段的菜单。请重试。`,
    FUTURE_ORDER_NO_AVAILABLE_SLOTS: `抱歉！未找到可用时间段。请尝试其他用餐选项。`,
    FUTURE_ORDER_SET_FOR: `订单预约时间：`,
    FUTURE_ORDER_VALIDATION_WHEN_SLOT_EXPIRED_ERROR: `抱歉！您选择的时间段已不可用。请选择其他时间。`,
    FUTURE_ORDER_ERROR_FETCHING_SLOTS: `获取可用时间段时出错。请重试。如问题持续，请联系工作人员。`,
    FUTURE_ORDER_ERROR_SELECT_SLOT: `请选择一个时间段。`,
    FUTURE_ORDER_TIME_SLOTS_TITLE: `可用时间段`,
    FUTURE_ORDER_TIME_SLOTS_TODAY: `今天`,
    FUTURE_ORDER_TIME_SLOTS_TOMORROW: `明天`,
    FUTURE_ORDER_PICKUP_TIME_TODAY_AT: `今天 {{$1: time}} 取餐`,
    FUTURE_ORDER_PICKUP_TIME_NEXT_BUSINESS_DAY_AT: `下一个工作日 {{$1: time}} 取餐`,
    FUTURE_ORDER_LEAD_TIME: `预计订单准备时间：{{$1: time}}`,
    GENERIC_ERROR: `哎呀！出现错误。请重试。如问题持续，请联系工作人员。`,
    GET_REWARDS: `获取奖励`,
    GET_RECEIPT: `获取收据`,
    GET_RECEIPT_DIALOG_TITLE: `收据选项`,
    GIFT_CARD: `礼品卡`,
    GIFT_CARD_SECONDARY: `备用礼品卡`,
    GIFT_CARD_TITLE: `立即支付`,
    GIFT_CARD_SUBTITLE: `在刷卡机上刷您的礼品卡进行支付。`,
    GIFT_CARD_SCANNING_ERROR_TITLE: `礼品卡扫描错误`,
    GIFT_CARD_SCANNING_ERROR_MESSAGE: `无法扫描您的礼品卡。请重试。`,
    GIFT_CARD_APPLYING_TITLE: `正在应用礼品卡`,
    GIFT_CARD_APPLYING_ERROR_TITLE: `礼品卡应用错误`,
    GIFT_CARD_APPLYING_ERROR_MESSAGE: `无法应用您的礼品卡。请重试。`,
    GIFT_CARD_NO_BALANCE_TITLE: `礼品卡余额不足`,
    GIFT_CARD_NO_BALANCE_MESSAGE: `您的礼品卡没有余额。`,
    GIFT_CARD_ADD_ANOTHER: `添加另一张`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_REQUIRED: `请输入礼品卡号码。`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_INVALID: `请输入有效的礼品卡号码。`,
    GIFT_CARD_ENTERING_NUMBER_ERROR_LENGTH: `请输入有效的礼品卡号码。`,
    GIFT_CARD_ENTERING_PIN_ERROR_REQUIRED: `请输入PIN码。`,
    GIFT_CARD_ENTERING_PIN_ERROR_INVALID: `请输入有效的PIN码。`,
    GIFT_CARD_ENTERING_PIN_ERROR_LENGTH: `请输入有效的PIN码。`,
    GIFT_CARD_ENTERING_NUMBER_HINT: `输入礼品卡号码。号码长度为 {{$1: length}} 位。`,
    GIFT_CARD_ENTERING_PIN_HINT: `输入PIN码。号码长度为 {{$1: length}} 位。`,
    GIFT_CARD_ERROR_REMOVING: `删除礼品卡时出错。请重试。如问题持续，请联系工作人员。`,
    'gift-card.select-account.title': `选择账户`,
    'gift-card.select-account.loading': `正在加载账户...`,
    'gift-card.select-account.error.title': `无法加载账户`,
    'gift-card.select-account.error.message': `无法加载您的账户。请重试。`,
    'gift-card.select-account.column.account': `账户`,
    'gift-card.select-account.column.balance': `当前余额`,
    'gift-card.select-account.error.toast-title': `错误`,
    'gift-card.select-account.error.toast-message': `验证失败。请重试。`,
    GLOSSARY_TERM_LEARN_MORE: `了解更多`,
    GOES_WELL_WITH: `搭配推荐`,
    GRAND_TOTAL: `总计`,
    GROUP_ORDERING_ADD_GUEST: `添加客人`,
    GROUP_ORDERING_GUEST_NAME_INVALID_CHARACTERS: `客人姓名包含无效字符。`,
    GROUP_ORDERING_GUEST_NAME_TAKEN: `此客人姓名已被使用。请输入其他姓名。`,
    GROUP_ORDERING_GUEST_NUMBER_PREFIX: `客人 {{$1: number}}`,
    GROUP_ORDERING_ITEM_FOR: `团体订单 - 此商品属于谁？`,
    GROUP_ORDERING_LABEL: `团体订单 - 商品属于：`,
    GROUP_ORDERING_TITLE: `团体订单`,
    GROUP_ORDERING_SUBTITLE: `团体订单选项将询问每件商品属于您一行中的哪位成员。点击"是"启用团体订单，点击"否"继续。`,
    GUEST_INFO: `客人信息`,
    GUEST_RATING_LABEL_0: `点击评为 0 分：非常不满意`,
    GUEST_RATING_LABEL_1: `点击评为 1 分：有点不满意`,
    GUEST_RATING_LABEL_2: `点击评为 2 分：有点满意`,
    GUEST_RATING_LABEL_3: `点击评为 3 分：非常满意`,
    GUEST_RATING_0: `感谢您提供反馈意见！`,
    GUEST_RATING_1: `感谢您提供反馈意见！`,
    GUEST_RATING_2: `感谢您提供反馈意见！`,
    GUEST_RATING_3: `感谢您提供反馈意见！`,
    GUEST_RATING_SUBMITTED: `感谢您提供反馈意见！`,
    HIDE: `隐藏`,
    HOME: `首页`,
    HOW_DID_WE_DO: `我们表现如何？请为我们评分！`,
    HOW_WOULD_YOU_LIKE_TO_PAY: `您希望如何支付？`,
    HOW_WOULD_YOU_LIKE_YOUR_ORDER: `您希望如何接收订单？`,
    KITCHEN_CLOSED: `抱歉，厨房已关闭。`,
    ID_CHECK_LABEL: `您的订单含有酒精饮品，可能需要出示身份证件。`,
    ID_CHECK_CODE_MESSAGE: `购买含酒精商品需要员工访问码。请寻求团队成员帮助。`,
    IE_WARNING: `我们注意到您正在使用 Internet Explorer 访问我们的网站。 为获得最佳体验，请使用支持的浏览器打开网页，例如 Google Chrome、Safari、Firefox 或 Microsoft Edge`,
    INCLUDE_UTENSILS: `包含餐具`,
    ITEM_86D: `您好，由于某商品缺货，向厨房发送订单时似乎出现问题。请联系工作人员获取帮助。`,
    ITEM_86D_VALIDATION: `您好，由于某件商品缺货，将您的订单发送至厨房时出现问题。请联系工作人员寻求帮助。`,
    ITEM_RECIPIENT: `为...制作`,
    ITEM_RECIPIENT_FOR: `为 {{$1: recipient}} 制作`,
    ITEM_RECIPIENT_PLACEHOLDER: ``,
    ITEM_RECOMMENDED_BADGE: `推荐`,
    ITEM_STEP_TITLE: `第 {{$1: step}} 步`,
    ITEM_STEP_EMPTY: `此步骤未作出任何选择`,
    ITEM_STEP_NO_RECOS: `暂无推荐`,
    ITEMS_NO_LONGER_IN_MENU: `部分商品已从您的购物车中移除，因为它们不再在菜单上`,
    ITEM_SCAN_ERROR: `未能找到该商品。请从菜单中添加，或向工作人员寻求帮助。`,
    ITEM_SCAN_SUCCESS: `商品已添加到购物车！`,
    LAST_NAME: `姓氏`,
    LEAD_TIME_LONG: `您的订单可能需要比当前所选时间段更长的准备时间。`,
    LEAD_TIME_CART: `由于部分已选商品，此订单可能需要比您要求的取餐时间更长的准备时间。`,
    LANGUAGE_SELECT_LABEL: `点击选择语言`,
    LOADING: `正在加载...`,
    LOADING_MENU: `正在加载菜单...`,
    LOCATION_CARD_CLOSED: ``,
    LOCATION_CARD_LAST_VISITED: ``,
    LOCATION_CARD_OPEN: ``,
    LOCATION_CARD_SERVING_UNTIL: ``,
    LOCATION_CARD_OPENS_NEXT: ``,
    LOCATION_SEARCH_BUTTON: `搜索门店`,
    LOCATION_SEARCH_FULFILLMENT_PROMPT: `查找 {{$1: dine-in/take-away}} 门店`,
    LOCATION_SEARCH_FULFILLMENT_QUESTION: `您希望如何点餐？`,
    LOCATION_SEARCH_HEADER: `欢迎来到 {{$1: org name}}`,
    LOCATION_SEARCH_INPUT_PLACEHOLDER: `地址、城市和省份，或邮政编码`,
    LOCATIONS_CHOOSE_A_LOCATION: ``,
    LOCATIONS_ENTER_DIFFERENT_CODE: ``,
    LOCATIONS_NONE_AVAILABLE: ``,
    LOG_IN_OR_JOIN: `登录`,
    LOGIN: `登录`,
    LOGIN_GIFT_CARD: `礼品卡登录`,
    LOGIN_GIFT_CARD_SECONDARY: `备用礼品卡登录`,
    LOGIN_WALL_WELCOME: `您好！`,
    LOGIN_WALL_WELCOME_USER: `您好，{{$1: user}}！`,
    LOGIN_WITH_CARD_NUMBER: `使用卡号登录`,
    LOGIN_WITH_PHONE: `使用手机登录`,
    LOOKING_UP_ACCOUNT: `正在查找账户...`,
    LOOKUP_CARD: `正在查找卡片...`,
    LOOKUP_COUPON: `正在查找优惠券...`,
    LOYALTY: `会员计划`,
    LOYALTY_ACCOUNT_APPLY: `应用`,
    LOYALTY_CARD_NUMBER: `卡号`,
    LOYALTY_EXIT_TO_MENU: `前往菜单`,
    LOYALTY_APP_AUTH_BARCODE_FALLBACK: `扫描应用二维码`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK: `没有应用？输入您的电话号码。`,
    LOYALTY_AUTH_METHOD_BARCODE: `扫描应用二维码`,
    LOYALTY_AUTH_METHOD_HID: `点击HID卡`,
    LOYALTY_AUTH_METHOD_PHONE: `输入您的电话号码。`,
    LOYALTY_AUTH_METHOD_CARD_NUMBER: `输入您的卡号。`,
    LOYALTY_AUTH_METHOD_EMAIL: `输入您的电子邮件。`,
    LOYALTY_AUTH_METHOD_EMAIL_PASSWORD: `输入您的电子邮件和密码。`,
    LOYALTY_AUTH_METHOD_EMAIL_PHONE: `输入您的电子邮件和电话号码。`,
    LOYALTY_AUTH_METHOD_USERNAME_PASSWORD: `输入您的用户名和密码。`,
    LOYALTY_APP_AUTH_PHONE_FALLBACK_LABEL: `输入您账户的电话号码：`,
    LOYALTY_APP_AUTH_SUBTITLE: `要找到条形码，请在应用中打开支付界面。`,
    LOYALTY_APP_AUTH_TITLE: `请用下方扫描仪扫描您应用的支付条形码。`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK: `手动输入7位奖励码`,
    LOYALTY_APP_REDEMPTION_CODE_FALLBACK_LABEL: `输入7位奖励码：`,
    LOYALTY_APPLY_REWARD_FAILED: `应用奖励失败。请重试。`,
    LOYALTY_APPLY_REWARD_FAILED_SPECIFIC: `无法应用以下奖励：{{$1: reward names}}。请重试。`,
    LOYALTY_APPLYING_REWARD: `正在应用奖励...`,
    LOYALTY_AUTH_GENERIC_ERROR: `抱歉！未找到此奖励账户。请重试。`,
    LOYALTY_AUTH_INSTRUCTIONS: `登录以赚取和使用您的积分计划积分。`,
    LOYALTY_AVAILABLE_REWARDS_LABEL: `可用奖励`,
    LOYALTY_BALANCE_DESCRIPTION: ``,
    LOYALTY_BALANCE_LABEL: `当前余额`,
    LOYALTY_CANNOT_MODIFY_REWARD: `抱歉，支付订单后无法修改您的奖励。`,
    LOYALTY_CANNOT_REMOVE_REWARD: `抱歉，此奖励一旦应用到订单就无法删除。`,
    LOYALTY_CARD_NUMBER_INSTRUCTIONS: `输入您的卡号以赚取和使用您的积分计划积分。`,
    LOYALTY_COUPON_BURNING_INCOMPATIBLE: `抱歉，由于已应用优惠券，您无法使用奖励。`,
    LOYALTY_GETTING_REWARDS: `正在获取您的奖励...`,
    LOYALTY_FETCH_REWARDS_FAILED: `获取奖励失败。请重试。`,
    LOYALTY_REWARD_APPLY: `应用`,
    LOYALTY_REWARD_APPLY_FAILED: `应用奖励失败。部分奖励可能不适用于您的订单。`,
    LOYALTY_REWARD_APPLIED: `已应用`,
    LOYALTY_REWARD_INVALID: `无效`,
    LOYALTY_REWARD_LABEL_MEAL: `餐食`,
    LOYALTY_REWARD_LABEL_MEALS: `餐食`,
    LOYALTY_REWARD_LABEL_UNSELECTED: `立即兑换`,
    LOYALTY_REWARD_LABEL_SELECTED: `已选择`,
    LOYALTY_REWARD_LABEL_APPLIED: `已兑换`,
    LOYALTY_REWARD_LABEL_UNAPPLIED: `结账时兑换`,
    LOYALTY_REWARD_LABEL_REMOVING: `正在删除`,
    LOYALTY_REWARD_LABEL_ERROR: `应用错误`,
    LOYALTY_REWARD_LABEL_UNAPPLICABLE: `不适用`,
    LOYALTY_REWARD_GROUP_LABEL_UNKNOWN: `奖励`,
    LOYALTY_REWARD_GROUP_LABEL_PERCENT: `百分比奖励`,
    LOYALTY_REWARD_GROUP_LABEL_FIXED: `固定奖励`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET: `钱包奖励`,
    LOYALTY_REWARD_GROUP_LABEL_WALLET_AND_PAYMENT: `钱包和支付奖励`,
    LOYALTY_REWARD_GROUP_LABEL_FREE_ITEM: `免费商品奖励`,
    LOYALTY_REWARD_GROUP_LABEL_MEAL_EQUIVALENCY: `餐食兑换奖励`,
    LOYALTY_REWARDS_FOR: `优惠券属于`,
    LOYALTY_NO_REWARDS_LABEL: `无奖励`,
    LOYALTY_NO_REWARDS_NO_EARNING: `这些商品没有可用的奖励。`,
    LOYALTY_NO_REWARDS_TEXT: `这些商品没有可用的奖励，但此订单仍可获得积分！`,
    LOYALTY_PAYMENT: `会员积分支付`,
    LOYALTY_PAYMENT_CARD_CHARGED: `将向存档卡收取 {{$1: charge_amount}}。`,
    LOYALTY_PAYMENT_FAILED: `支付应用失败。`,
    LOYALTY_PAYMENT_FAILED_MESSAGE: `处理会员积分支付时出现问题。请重试或选择其他支付方式。`,
    USE_LOYALTY_PAYMENT: `使用会员积分`,
    LOYALTY_PAYMENT_SUBMIT: `完成支付`,
    LOYALTY_PAYMENT_REWARD: `从会员积分扣款`,
    LOYALTY_PAYMENT_REWARD_DESCRIPTION: `您在服务商处存档的卡将被扣款用于此交易。`,
    LOYALTY_PAY_WITH_APP: `使用应用支付`,
    LOYALTY_EARNED_POINT_ESTIMATE: `此订单预计获得的奖励积分：`,
    LOYALTY_EARNED_POINT_ESTIMATE_METRIC: `{{$1: number }} 积分`,
    LOYALTY_INTRO_ACCOUNT_STATUS: `账户状态`,
    LOYALTY_INTRO_COULD_NOT_FIND_ACCOUNT: `未找到您的账户。`,
    LOYALTY_INTRO_LOGIN_AND_EARN: `请在下方登录您的账户以赚取积分和兑换奖励。`,
    LOYALTY_INTRO_PHONE_SIGN_UP: `使用手机号码注册`,
    LOYALTY_INTRO_PHONE_SIGN_UP_DESCRIPTION: `注册后扫描订单收据，您仍可赚取今天订单的积分！`,
    LOYALTY_INTRO_QR_SIGN_IN: `请扫描下方二维码登录。`,
    LOYALTY_INTRO_QR_SIGN_UP: `请扫描下方二维码注册。`,
    LOYALTY_INTRO_WELCOME_BACK: `欢迎回来，`,
    LOYALTY_FETCH_REWARDS_FAILED_NON_UNIQUE: `您提供的电话号码与多个会员账户关联或不存在。`,
    LOYALTY_REDEMPTION_CODE: `应用兑换码`,
    LOYALTY_REMOVING_REWARD: `正在删除奖励...`,
    LOYALTY_SCAN_FAILED_TITLE: `扫描失败`,
    LOYALTY_SCAN_FAILED_MESSAGE: `无法扫描您的二维码。请重试。`,
    LOYALTY_SIGN_OUT_NOTICE: `下单或退出菜单时将自动退出登录。`,
    LOYALTY_SIGN_OUT_NOTICE_PASSWORD: `下单或退出菜单时将自动退出登录。密码不会被保存。`,
    LOYALTY_SIGN_UP_SMS_SENT: `注册短信已发送！`,
    LOYALTY_SIGN_UP_BACK_TO_LOGIN: `返回登录`,
    LOYALTY_SIGN_UP_SUCCESS_TITLE: `注册成功！`,
    LOYALTY_SIGN_UP_WITH_QR: `使用二维码注册`,
    LOYALTY_SIGN_UP_WITH_PHONE_NUMBER: `使用手机号码注册`,
    LOYALTY_WELCOME_TITLE: `赚取和使用奖励`,
    LOYALTY_SIGNUP_TITLE: `接收发送到您手机的注册链接`,
    LOYALTY_YOU_CURRENTLY_HAVE: `您目前拥有`,
    LOYALTY_NAV_REWARDS: `我的奖励`,
    LOYALTY_NAV_ORDER_HISTORY: `我的订单`,
    LOYALTY_SIGN_IN_ATTEMPTS_EXCEEDED: `您已超过最大登录尝试次数。`,
    GIFT_CARD_ACCESS_ATTEMPTS_EXCEEDED: `您已超过最大礼品卡访问尝试次数。`,
    MAKE_IT_A_COMBO: `加入套餐？`,
    MAKE_IT_A_COMBO_MOD: `做成套餐？`,
    MAKE_IT_A_COMBO_ACCEPT: `好的，请加入！`,
    MAKE_IT_A_COMBO_REJECT: `不，谢谢！`,
    MAKE_IT_A_COMBO_NO: `不，谢谢，不要套餐。`,
    MAKE_IT_A_COMBO_YES: `加入套餐？`,
    MAKE_IT_A_COMBO_ACCEPTED_TITLE: `好选择！`,
    MAKE_IT_A_COMBO_ACCEPTED_MESSAGE: `请在下方选择您的配菜和饮料！`,
    MAKE_IT_A_COMBO_CHECKOUT_UPSELL_SUBTITLE: `添加配菜和饮料组成套餐！`,
    MENU_COVER_ALT_TEXT: `点击此处开始点餐`,
    MENU_COVER_LOYALTY_TEXT: `登录会员账户赚取积分和兑换奖励`,
    MENU_COVER_QUIZ_TEXT: `参加测验，找到最适合您的菜品！`,
    MENU_COVER_WAYFINDER_TEXT: `前往我们的导览找到您想去的地方`,
    MAINTENANCE_COVER_TITLE: `此自助机正在维护中`,
    MAINTENANCE_HID_DISCONNECTED_MESSAGE: `请确保HID已连接至自助机。`,
    MAINTENANCE_HID_DISCONNECTED_TITLE: `HID断开连接`,
    MAINTENANCE_KDS_DISCONNECTED_MESSAGE: `请确保KDS已连接至自助机。`,
    MAINTENANCE_KDS_DISCONNECTED_TITLE: `KDS断开连接`,
    MAINTENANCE_KIOSK_UNAVAILABLE_MESSAGE: `请尝试使用其他自助机或寻求工作人员帮助。`,
    MAINTENANCE_KIOSK_UNAVAILABLE_TITLE: `此自助机目前不可用`,
    MAINTENANCE_MSR_DISCONNECTED_MESSAGE: `请确保磁条读卡器已连接至自助机。`,
    MAINTENANCE_MSR_DISCONNECTED_TITLE: `磁条读卡器断开连接`,
    MAINTENANCE_NETWORK_DISCONNECTED_MESSAGE: `请确保自助机已连接至网络。`,
    MAINTENANCE_NETWORK_DISCONNECTED_TITLE: `无网络连接`,
    MAINTENANCE_NETWORK_UNSTABLE_MESSAGE: `由于网速较慢，此自助机连接出现问题。请检查您的连接是否稳定。推荐网速：上传和下载均最低10 Mbps。`,
    MAINTENANCE_NETWORK_UNSTABLE_TITLE: `检测到网络不稳定`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_MESSAGE: `请确保支付设备已开启并连接至自助机。`,
    MAINTENANCE_PAYMENT_CLIENT_DISCONNECTED_TITLE: `支付设备断开连接`,
    MAINTENANCE_PRINTER_COVER_OPEN_MESSAGE: `请确保打印机盖已关闭。`,
    MAINTENANCE_PRINTER_COVER_OPEN_TITLE: `打印机盖未关闭`,
    MAINTENANCE_PRINTER_DISCONNECTED_MESSAGE: `请确保打印机已连接至自助机。`,
    MAINTENANCE_PRINTER_DISCONNECTED_TITLE: `打印机断开连接`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_MESSAGE: `请确保打印机有纸。`,
    MAINTENANCE_PRINTER_OUT_OF_PAPER_TITLE: `打印机缺纸`,
    MAINTENANCE_SCALE_DISCONNECTED_MESSAGE: `请确保秤已连接至自助机。`,
    MAINTENANCE_SCALE_DISCONNECTED_TITLE: `秤断开连接`,
    MAINTENANCE_SCANNER_DISCONNECTED_MESSAGE: `请确保扫描仪已连接至自助机。`,
    MAINTENANCE_SCANNER_DISCONNECTED_TITLE: `扫描仪断开连接`,
    MAX_ALCOHOLIC_ITEM_LIMIT_REACHED: `每单最多允许 {{$1: number}} 件含酒精饮品`,
    MAX_SPECIAL_ITEM_LIMIT_REACHED: `每单最多允许 {{$1: number}} 件特价商品`,
    MENU_COVER_DINING_OPTIONS: `您希望如何点餐？`,
    MENU_COVER_LANGUAGE_OPTIONS: `请选择语言开始`,
    MENU_COVER_PROMO_ALT_TEXT_ITEM: `点击此处开始点餐并查看此推广商品：{{$1: item name}}！`,
    MENU_COVER_PROMO_ALT_TEXT_SECTION: `点击此处开始点餐并直接前往此推广部分：{{$1: section name}}！`,
    MENU_COVER_PROMO_ALT_TEXT_PAGE: `点击此处开始点餐并直接前往此推广页面：{{$1: page name}}！`,
    MENU_COVER_DINING_OPTION_ALT_TEXT: `点击此处开始"{{$1: fulfillment method}}"订单！`,
    MENU_COVER_BACK_TO_DINING_OPTIONS: `返回用餐选项`,
    MENU_COVER_BACK_TO_PHONE_NUMBER: `返回电话号码`,
    MARKETING_CONSENT: `我希望接收新闻、更新、折扣和优惠`,
    MENU_FILTERS_DIETARY_FILTERS: `饮食选项`,
    MENU_FILTERS_DIETARY_FILTERS_DESCRIPTION: `为了保证健康饮食，请从以下选项选择一项，作为显示在菜单上的唯一选项`,
    MENU_FILTERS_NUTRITION_PREFERENCE: `营养偏好`,
    MENU_FILTERS_OTHER_FILTERS: `其他`,
    MENU_FILTERS_OTHER_FILTERS_DESCRIPTION: ``,
    MENU_FILTERS_RESTRICTIVE_FILTERS: `限制性`,
    MENU_FILTERS_RESTRICTIVE_FILTERS_DESCRIPTION: `如果您对某些食物不耐受，请从中选择一项，将其从菜单中隐藏`,
    MENU_FILTERS_COUNT: `{{$1: number}} 项营养偏好已启用。点击编辑。`,
    MOD_86D: `您好，由于某件商品缺货，将您的订单发送至厨房时出现问题。请联系工作人员寻求帮助。请注意，餐厅已接受了您的付款。`,
    MOD_GROUP_AGGREGATE_QUANTITY: `共 {{$1: number range, e.g. 2-3}} 项`,
    MOD_GROUP_CHOICES_INCREMENT: `{{$1: number, e.g. you have to get 2/4/6 sauces}} 的倍数`,
    MOD_GROUP_CHOICES_MAKE_ONE: `请仅选择一项`,
    MOD_GROUP_CHOICES_MAKE_X: `请选择 {{$1: number range, e.g. 2-3}} 个不同的选项`,
    MOD_GROUP_CHOICES_QUANTITY_PER: `每项选择 {{$1: number range, e.g. 2-3}} 个`,
    MOD_GROUP_CHOOSE_AT_LEAST_X: `至少选择 {{$1: number}} 项`,
    MOD_GROUP_CHOOSE_BETWEEN_X_AND_Y: `选择 {{$1: number}} 至 {{$2: number}} 项`,
    MOD_GROUP_CHOOSE_ONE: `选择一项`,
    MOD_GROUP_CHOOSE_UP_TO_ONE: `最多选择一项`,
    MOD_GROUP_CHOOSE_UP_TO_X: `最多选择 {{$1: number}} 项`,
    MOD_GROUP_CHOOSE_X: `选择 {{$1: number}} 项`,
    MOD_GROUP_DEEMPHASIZE_SHOW: `显示 - {{$1: mod_group}}`,
    MOD_GROUP_DEEMPHASIZE_HIDE: `隐藏 - {{$1: mod_group}}`,
    MOD_GROUP_WALLET_$_TO_SPEND: `收费前还可以消费 {{$1: dollar amount}}。`,
    MOD_GROUP_WALLET_ADDITIONAL_CHOICES_AT_$_PER: `额外选项每项 {{$1: dollar amount}}。`,
    MOD_GROUP_WALLET_FIRST_X_FREE: `前 {{$1: number}} 项免费。`,
    MOD_GROUP_WALLET_FIRST_SINGLE_FREE: `第一项免费。`,
    MOD_GROUP_WALLET_UP_TO_X: `每个选择最多可选 {{$1: number}} 项，每项 {{$2: dollar amount}}`,
    MOD_GROUP_SUBSTITUTION_MOD_CANCEL: `关闭替换`,
    MOD_GROUP_SUBSTITUTION_MOD_CHANGE: `更改替换`,
    MOD_GROUP_SUBSTITUTION_MOD_SELECT: `替换`,
    MOD_GROUP_SUBSTITUTION_UNSELECTED: `添加到商品`,
    MOD_RECOMMENDED_BADGE: `推荐`,
    MOD_UPSELL_PROMPT_TITLE: `添加选项？`,
    MOD_UPSELL_PROMPT_ACCEPT: `添加`,
    MOD_UPSELL_PROMPT_DECLINE: `不，谢谢`,
    MODIFY: `修改`,
    MODIFY_INGREDIENTS: `修改配料`,
    MORE: `更多`,
    NAME_CALLED_ORDER_READY: `订单准备好后将呼叫您的姓名。`,
    NAME_ON_CARD: `持卡人姓名`,
    NEED_MORE_TIME: `需要更多时间？`,
    NEW_PASSWORD: `新密码`,
    NEXT: `下一步`,
    NO: `否`,
    NO_ITEMS_MATCH_FILTERS: `没有商品符合您的筛选条件。`,
    NO_ORDERS_MATCH: `没有订单符合您的搜索。`,
    NO_THANKS: `不，谢谢`,
    NO_TIP: `不加小费`,
    NOT_A_MEMBER: `还不是会员？`,
    NUTRITION_INFO_CALORIES: `卡路里`,
    NUTRITION_INFO_PROTEIN: `蛋白质`,
    NUTRITION_INFO_FAT: `脂肪`,
    NUTRITION_INFO_CARBS: `碳水化合物`,
    NUTRITION_INFO_SUGAR: `糖分`,
    OK: `确定`,
    OR: `或`,
    OPT_OUT_OF_RECOMMENDATIONS: `不接受推荐`,
    ORDER_GET_ERROR: `抱歉，创建您的订单时遇到问题。请重试。`,
    ORDER_HISTORY: `订单历史`,
    ORDER_HISTORY_EMPTY: `您的历史记录中没有订单。下单后，订单将显示在此处。`,
    ORDER_HISTORY_ERROR: `抱歉，加载您的订单历史时遇到问题。请重试。`,
    ORDER_SENT: `订单已发送`,
    ORDER_SUMMARY: `订单摘要`,
    ORDER_SUMMARY_WITH_NAME: `{{$1 guest name}} 的订单摘要`,
    ORDER_SUMMARY_LABEL: `订单摘要。{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_NAME: `订单摘要。{{$2 guest name}} 的{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_TABLE: `订单摘要。桌号 {{$2: table number}} 的{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER: `订单摘要。追踪器 #{{$2: tracker number}} 的{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TABLE: `订单摘要。{{$2 guest name}} 在桌号 {{$3: table number}} 的{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_TRACKER: `订单摘要。{{$2 guest name}} 追踪器 #{{$3: tracker number}} 的{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_ORDER_NUMBER: `订单摘要。订单 #{{$2: order number}} 的{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_TRACKER_AND_ORDER_NUMBER: `订单摘要。追踪器 #{{$2: tracker number}}、订单 #{{$3: order number}} 的{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_TABLE_AND_ORDER_NUMBER: `订单摘要。桌号 {{$2: table number}}、订单 #{{$3: order number}} 的{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_NAME_AND_ORDER_NUMBER: `订单摘要。{{$2 guest name}} 订单 #{{$3: order number}} 的{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TABLE_AND_ORDER_NUMBER: `订单摘要。{{$2 guest name}} 在桌号 {{$3: table number}}、订单 #{{$4: order number}} 的{{$1 fulfillment}}订单`,
    ORDER_SUMMARY_LABEL_WITH_NAME_TRACKER_AND_ORDER_NUMBER: `订单摘要。{{$2 guest name}} 在追踪器 #{{$3: tracker number}}、订单 #{{$4: order number}} 的{{$1 fulfillment}}订单`,
    ORDER_THROTTLE_MAX_EXCEEDED: `抱歉！餐厅的订单量超出处理能力。请尝试选择其他时间段。`,
    ORDER_TIME_ASAP: `尽快下单`,
    ORDER_TIME_LATER: `今天稍晚`,
    ORDER_TIME_NEXT_BUSINESS_DAY: `下一个工作日`,
    ORDER_TIME_FUTURE: `预约点餐`,
    ORDER_TOTAL_MAX_EXCEEDED: `大额订单请联系工作人员。`,
    ORDER_UPDATE_FAILED: `更新订单失败。`,
    ORDER_VALIDATION_IN_PROGRESS: `正在验证您的订单`,
    ORDER_VALIDATION_FAILED: `哎呀！出现错误。`,
    ORDER_WAS_PLACED: `您的订单已下单。`,
    ORDERING_MODE_CHANGED: `点餐模式已更改。您的会话已重置。`,
    ORDERED_ITEM_MAKE_IT_A_COMBO_LABEL: `点击此处将 {{$1: ordered item name}} 做成套餐。`,
    ORDERED_ITEM_COMBO_LABEL: `套餐`,
    ORDERING_ITEM_ABSENCE_RESET: `此商品已过期。商品已重置为初始状态。请重试。`,
    OUR_MENU: `我们的菜单`,
    OUTPOST_PICKUP: `前哨站取餐`,
    OUTPOST_ROOM_NUMBER_INSTRUCTION: `输入您的前哨站房间号`,
    OUTPOST_ROOM_NUMBER_TITLE: `房间号`,
    OUT_OF_STOCK: `缺货`,
    PAGE_NAVIGATION_TITLE: `点击下方任一选项前往菜单中的特定页面。共有 {{$1: total}} 个页面可用。`,
    PARTIAL_PAYMENT_LINE: `部分支付`,
    PARTIAL_PAYMENT_WARNING_TITLE: `部分支付`,
    PARTIAL_PAYMENT_WARNING_MESSAGE: `此订单有部分付款。如果您想返回，您的付款将先被退款。`,
    PASSWORD: `密码`,
    PASSWORD_REQUIREMENTS: ``,
    PASSWORD_UPDATED: ``,
    PASSWORD_UPDATED_LOG_IN_AGAIN: ``,
    PARTIAL_TENDER_TIMEOUT: `您好，如果您在接下来的5分钟内未完成付款，我们将取消订单并退款。`,
    PAY_AT_CASHIER: `请前往收银台付款。`,
    PAY_NOW: `立即支付`,
    PAY_WITH: `支付方式`,
    PAY_WITH_CREDIT: `信用卡支付`,
    PAY_WITH_DEBIT_CREDIT: `借记/信用卡支付`,
    PAYMENT: `支付`,
    PAYMENT_DETAILS: `支付详情`,
    PAYMENT_LINE_LABEL_DONATION: `捐款 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SUBTOTAL: `小计为 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PARTIAL: `部分支付 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_GIFT_CARD: `使用 {{$1: name}} 礼品卡兑换 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COUPON: `来自 {{$1: name}} 的优惠券折扣 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_COMP_CARD: `来自 {{$1: name}} 的优惠券折扣 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_EBT: `使用 EBT 支付 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_LOYALTY: `使用 {{$1: name}} 会员积分兑换 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_REWARD: `使用 {{$1: name}} 奖励兑换 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_DISCOUNT: `来自 {{$1: name}} 的折扣 {{$2: amount}}`,
    PAYMENT_LINE_LABEL_TAX: `税费为 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_TIP: `小费为 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_SERVICE_CHARGE: `服务费 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_NAMED_SERVICE_CHARGE: `{{$2: name}} 服务费 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_TOTAL: `总计为 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_REMAINING: `剩余余额为 {{$1: amount}}`,
    PAYMENT_LINE_LABEL_PAID: `已支付金额为 {{$1: amount}}`,
    PAYMENT_OPTION_LABEL_CASH: `点击使用现金支付`,
    PAYMENT_OPTION_LABEL_CARD: `点击使用信用卡支付`,
    PAYMENT_OPTION_LABEL_COUPON: `点击兑换优惠券`,
    PAYMENT_OPTION_LABEL_COMP_CARD: `点击兑换优待卡`,
    PAYMENT_OPTION_LABEL_DONATION: `点击进行或编辑捐款`,
    PAYMENT_OPTION_LABEL_EBT: `点击使用 EBT 支付`,
    PAYMENT_OPTION_LABEL_EBT_REFUND: `点击退款 EBT`,
    PAYMENT_OPTION_LABEL_EBT_CASH_BENEFIT: `点击使用 EBT 现金福利支付`,
    PAYMENT_OPTION_LABEL_EBT_FOOD_STAMPS: `点击使用 EBT 食品券支付`,
    PAYMENT_OPTION_LABEL_GIFT_CARD: `点击使用礼品卡支付`,
    PAYMENT_OPTION_LABEL_LOYALTY: `点击兑换奖励`,
    PAYMENT_OPTION_LABEL_LOYALTY_PAYMENT: `点击兑换奖励`,
    PAYMENT_OPTION_LABEL_FULLY_PAID: `点击完成支付`,
    PAYMENT_PROMPT_NFC: `请在终端上插入卡片或靠近手机进行支付。`,
    PAYMENT_PROMPT_DIP: `请在终端上插入卡片进行支付。`,
    PAYMENT_SUCCESSFUL: `支付成功`,
    PAYMENT_SUCCESSFUL_SUBTITLE: ``,
    PAYMENT_KIOSK_ERROR: `抱歉，您的支付失败。请重试。`,
    PAYMENT_KIOSK_TIMEOUT: `抱歉，支付会话已超时。请重试。`,
    PAYMENT_TOTAL: `支付总额`,
    PAYMENT_WAS_TAKEN: `请注意，您的付款已处理。`,
    PAYMENT_WAS_NOT_TAKEN: `请注意，您的付款未处理。这不是付款确认。`,
    PHONE_NUMBER: `电话号码`,
    PICK_UP: `自取`,
    PICK_UP_AT: `取餐地点`,
    PICK_UP_ENTER_NUMBER: `请取一个号码牌并在下方输入：`,
    PICK_UP_ENTER_NUMBER_WITH_NAME: `您好 {{$1: guest name}}，请取一个号码牌并在下方输入：`,
    PICK_UP_ENTER_NUMBER_TRACKER: `请取一个追踪器并输入其编号：`,
    PICK_UP_ENTER_NUMBER_TRACKER_WITH_NAME: `您好 {{$1: guest name}}，请取一个追踪器并输入其编号：`,
    PLACE_ORDER: `下单`,
    PLEASE_ENTER_A_VALID_AMOUNT: `请输入有效的退款金额。`,
    PLEASE_USE_TEST_CARD: `此地点仍处于测试模式。请使用测试卡支付。`,
    PLEASE_WAIT: `请稍候...`,
    PRICE: `价格为 {{$1:price}}`,
    PRINTING_RECEIPT: `正在打印您的收据...`,
    PRINT_RECEIPT: `打印收据`,
    PRINT_RECEIPT_ERROR: `抱歉，打印收据时出错。请稍后重试。`,
    PRINTED_RECEIPT_COMMAND: `请记得取走您的收据！`,
    PROCESSING_PAYMENT: `正在处理支付...`,
    PROMOTED_MODIFIER: `促销！`,
    QUANTITY_SELECT: `已选择 {{$1:quantity}}`,
    QUANTITY_SELECT_INCREASE: `增加数量`,
    QUANTITY_SELECT_DECREASE: `减少数量`,
    QUANTITY_SELECT_LABEL: ``,
    QUIT: `退出`,
    QUICK_CHECKOUT: `快速结账`,
    QUICK_NAV_TAP_TO_VIEW: `点击查看：`,
    QUIZ_RESULTS_TITLE: `结果`,
    QUIZ_RESULTS_EMPTY: `未找到结果。请尝试其他答案后重试。`,
    QUIZ_RESULTS_CAROUSEL_NEXT_LABEL: `点击查看下一个结果。第 {{$1:index}} 个，共 {{$2:total}} 个`,
    QUIZ_RESULTS_CAROUSEL_PREV_LABEL: `点击查看上一个结果。第 {{$1:index}} 个，共 {{$2:total}} 个`,
    QUIZ_STEP_ERROR: `请回答所有问题后再继续。`,
    QUIZ_STEP_ANSWER_LABEL: `点击以 {{$1:badge name}} 作答：`,
    QR_CODE_RECEIPT_INSTRUCTIONS: `扫描二维码在您的手机上获取收据副本。`,
    RECEIPT_AUTHORIZATION: `授权`,
    RECEIPT_CARD_NUMBER: `卡号`,
    RECEIPT_CHECK_ID: `账单号`,
    RECEIPT_DISCOUNTS: `折扣`,
    RECEIPT_DONATION: `捐款`,
    RECEIPT_FAILED: `您好，向厨房发送订单时似乎出现问题。请联系工作人员获取帮助。`,
    RECEIPT_FAILED_ITEM_86D: `您好，由于某件商品缺货，将订单发送至厨房时出现问题。请联系工作人员寻求帮助。`,
    RECEIPT_LOYALTY_POINTS_EARNED_TEXT: ``,
    RECEIPT_MENU_ITEMS_WITHOUT_BARCODE: `以下商品未包含在二维码中，因为它们没有关联的 PLU：`,
    RECEIPT_NOT_RECEIPT: `这不是收据或购买证明。`,
    RECEIPT_ORDER: `订单`,
    RECEIPT_ORDER_TOTAL: `订单总计`,
    RECEIPT_PAY_AT_CASHIER: `请前往收银台付款`,
    RECEIPT_PICK_UP_AT_LABEL: `取餐地点`,
    RECEIPT_PICKUP_TIME_LABEL: `取餐时间`,
    RECEIPT_DELIVERY_TIME_LABEL: `配送时间`,
    RECEIPT_PRINTED: `收据已打印`,
    RECEIPT_REFUNDED: `已退款`,
    RECEIPT_REMAINING_BALANCE: `剩余余额`,
    RECEIPT_SELF_SERVE: `自助：`,
    RECEIPT_SPECIAL_REQUEST: `特殊要求`,
    RECEIPT_SUB_TOTAL: `小计`,
    RECEIPT_TAX_TOTAL: `税费合计`,
    RECEIPT_TIP_THANKS: `小费（谢谢！）`,
    RECEIPT_SERVICE_CHARGE: `服务费`,
    RECEIPT_TRANS_NO: `售货亭交易号`,
    RECEIPT_YOUR_CHECK_NUMBER: `您的账单号码是`,
    RECOMMENDATIONS: `推荐`,
    RECOMMENDED_FOR_YOU: `为您推荐`,
    REFUND: `退款`,
    REFUNDER_ALREADY_REFUNDED: `已退款`,
    REFUNDER_DELAY_MESSAGE: `退款可能需要几天时间才能显示在您的账户对账单上。`,
    REFUNDER_INSTRUCTIONS: `使用收据上的授权号、订单号、电子邮件地址、电话号码、支付卡后四位数字、交易参考号或订单 ID 搜索订单。`,
    REFUNDER_SEARCH_PLACEHOLDER: `收据授权号、订单号或支付卡后四位数字`,
    REFUNDER_TITLE: `退款订单`,
    REFUNDER_SEARCHING_TITLE: `正在搜索`,
    REFUNDER_RESULTS_TITLE: `订单`,
    REFUNDER_RESULTS_EMPTY: `未找到订单。请仔细检查您的搜索条件后重试。`,
    REFUNDER_REFUNDING_TITLE: `正在退款`,
    REFUNDER_REFUND_ERROR: `处理您的退款时出错。请重试。如问题持续，请联系支持。`,
    REFUNDER_REFUND_SUCCESS: `退款成功！交易将很快处理。`,
    REFUNDER_REFUND_SUCCESS_BACK: `再次搜索`,
    REFUNDER_SEARCH_INPUT_ERROR: `请输入有效的授权号、订单号或支付卡后四位数字。`,
    REFUNDER_SEARCH_ERROR: `搜索您的订单时出错。请重试。如问题持续，请联系支持。`,
    REFUNDING: `正在处理退款...`,
    REFUND_FAILED: `退款失败。请稍后重试。`,
    REMOVE: `删除`,
    REMOVE_CARD: `请记得取出您的卡片。`,
    REMOVE_COMP_CARD: `删除优待卡`,
    REMOVE_COUPON: `删除优惠券`,
    REMOVE_GIFT_CARD: `删除`,
    REMOVE_TIP: `删除小费`,
    REMOVING_COUPON: `正在删除优惠券...`,
    REORDER: ``,
    REPEAT_PASSWORD: `重复密码`,
    RESET: `重置`,
    REWARDS: `奖励`,
    REWARDS_LOGGED_IN: `奖励`,
    REWARDS_APPLICABLE_TO_ORDER: `现在适用于您的订单`,
    REWARDS_NOT_APPLICABLE_TO_ORDER: `尚不适用于您的订单`,
    REWARDS_EDIT: `编辑奖励`,
    REWARDS_BALANCE_POINT_LABEL: `{{$1: number}} 点`,
    REWARDS_BALANCE_MEAL_EQUIVALENCY_LABEL: `{{$1: number}} 份餐食`,
    REWARDS_COST_POINT_LABEL: `{{$1: number}} 点`,
    SAVE: `更新`,
    SAVE_CARD: `将卡片保存到账户以供将来购买使用。`,
    SCAN_COUPON_BELOW: `您可以使用下方扫描仪扫描优惠券。`,
    SCAN_YOUR_GIFT_CARD: `扫描您的礼品卡`,
    SEARCH: `搜索`,
    SEARCH_BEGIN: `在下方输入搜索词以开始搜索。`,
    SEARCH_EMPTY: `未找到结果。请尝试其他搜索词。`,
    SEARCH_HINT: `使用名称或描述的任意组合搜索商品。`,
    SECRET_MENU_IMAGE_ALT: `点击查看秘密菜单`,
    SELECT_DATE: `选择日期`,
    SELF_SERVE: `自助服务`,
    SEND: `发送`,
    SEND_LOYALTY_SMS: `发送短信`,
    SEND_ORDER_UI_TIMEOUT: `您好，我们仍在尝试将您的订单发送到厨房。请联系工作人员寻求帮助。`,
    SENT_LOYALTY_SIGNUP_SMS: `短信已发送！请查看您的电话并在方便时注册。`,
    SENDING_ORDER_KITCHEN: `正在将订单发送至厨房...`,
    SENDING_ORDER_VALIDATION: `正在确认您的订单...`,
    SENDING_RECEIPT: `正在发送收据...`,
    SENDING_SMS: `正在发送消息...`,
    SERVICE_CHARGE: `服务费`,
    SHOW: `显示`,
    SHOW_NUTRITION: `显示营养信息`,
    SHOW_STAFF_FIRST: `请在退出前向工作人员出示此消息。\n真的要退出吗？`,
    SIGNUP_CTA: `注册新帐户！`,
    SIGN_OUT: `退出登录`,
    SIGN_UP: `注册`,
    SIGNUP_BENEFITS: `创建账户以保存您的信用卡和收藏商品，享受更便捷的结账体验。`,
    SIGNUP_LOYALTY: `注册会员计划`,
    SKIP: `跳过`,
    SPECIAL_REQUESTS: `特殊要求`,
    SPECIAL_REQUESTS_EXAMPLE: `例：酱料另放、不要凤尾鱼等。`,
    SPECIAL_REQUESTS_FINEPRINT: `替换和特殊要求可能产生额外费用。`,
    SPECIAL_REQUESTS_ADD: `添加特殊要求`,
    SPECIAL_REQUESTS_ERROR_TOO_LONG: `特殊要求过长。`,
    SPECIAL_REQUESTS_ERROR_NO_INVALID_CHARACTERS: `请仅使用字母、数字和标点符号。`,
    SPECIAL_REQUESTS_ERROR_NO_VALUE: `请输入特殊要求。`,
    SR_REMOVE_ITEM_FROM_CART: `从购物车中删除商品。`,
    STARTING_ORDER: `正在启动订单...`,
    UPDATING_ORDER: `正在更新订单...`,
    START_ORDER_BY_SCANNING: `通过扫描自助机底部的商品开始点餐。`,
    START_NEW_ORDER: `再下一单`,
    STORED_VALUE_REMAINING_BALANCE: `余额`,
    STORE_INFO: ``,
    STORE_INFORMATION: `门店信息`,
    STUDENT_CARD: `学生卡`,
    STUDENT_CARD_INSUFFICIENT_FUNDS: `抱歉，此学生卡余额不足。`,
    STUDENT_CARD_SUBTITLE_HID: `点击您的学生卡付款`,
    STUDENT_CARD_SUBTITLE_HID_MSR: `点击或刷您的学生卡付款`,
    STUDENT_CARD_SUBTITLE_MSR: `刷您的学生卡付款`,
    SUBMIT: `提交`,
    SUBTOTAL: `小计`,
    SUBTOTAL_REDUCED: `折扣后小计`,
    SUBTOTAL_INCREASED: `新小计金额`,
    SUBTOTAL_WARNING_COMBO_SAVE_TITLE: `套餐为您省钱！`,
    SUBTOTAL_WARNING_COMBO_SAVE_LINE: `您已节省`,
    SUCCESS: `成功`,
    SUMMARY_STEP_FOOTNOTE: ``,
    SUMMARY_STEP_NOTICE: ``,
    SWITCH_LOCATION: `切换地点`,
    SWITCH_TO_CATERING: `切换至餐饮服务`,
    SWITCH_TO_WEB: `切换至在线点餐`,
    SWIPE_YOUR_GIFT_CARD: `刷礼品卡支付`,
    SWIPE_YOUR_COMP_CARD: `刷优待卡支付`,
    SWIPE_OR_SCAN_YOUR_GIFT_CARD: `刷卡或扫描礼品卡支付`,
    TAKING_LONGER_THAN_USUAL: `比平时花费更长时间...`,
    TAP_HERE_FOR_LANGUAGE: `点击此处选择 {{$1: language}}`,
    TAP_OUTSIDE_CLOSE: `点击外部关闭`,
    TAP_TO_REDEEM: `点击兑换`,
    TAXES: `税费`,
    TERMS_OF_SERVICE: `服务条款`,
    TERMS_OF_SERVICE_LOAD_FAILED: `加载服务条款时出错`,
    TEXT_RECEIPT: `短信收据`,
    TEXT_RECEIPT_SEND_FAILED: `无法发送短信收据。`,
    TEXT_RECEIPT_SEND_SUCCESS: `收据已发送！`,
    TEXT_YOU_WHEN_READY: `订单准备好后我们将发送短信通知您。`,
    THANK_YOU: `谢谢！`,
    THEN_PRESS_BUTTON_1: `然后按`,
    THEN_PRESS_BUTTON_2: `按钮。`,
    TIP: `小费`,
    TIPPING: `正在添加小费...`,
    TIP_AMOUNT_TOO_HIGH: `小费金额过高。`,
    TIP_AMOUNT_TOO_LOW: `小费金额过低。`,
    TIP_FAILED: `抱歉！无法添加小费。请重试。`,
    TIP_CANNOT_BE_MODIFIED: `抱歉！支付订单后无法修改您的小费。`,
    TIP_LABEL_PERCENT: `点击添加 {{$1: percent}}%（{{$2: amount}}）的小费`,
    TIP_LABEL_FIXED: `点击添加 {{$1: amount}} 的小费`,
    TIP_LABEL_CUSTOM: `点击添加自定义小费`,
    TIP_LABEL_NONE: `点击删除小费`,
    TO_GO: `外带`,
    TOTAL: `总计`,
    TOTAL_CHANGED_SUBTOTAL_TEXT: `您订单中部分商品的价格已更改。`,
    TOTAL_CHANGED_SUBTOTAL_LEADING_TEXT: `小计已更改，现在是`,
    TOTAL_CHANGED_LEADING_TEXT: `总金额已更改，现在是`,
    TOTAL_CHANGED_TRAILING_TEXT: `。您要继续点餐吗？`,
    TOTAL_PAID: `已支付总额`,
    TOTAL_REMAINING: `剩余金额`,
    TOTAL_SUBSCRIPT: ``,
    TRY_AGAIN: `重试`,
    UNABLE_TO_FETCH_LOCATION_EXPLANATION: `我们似乎无法获取您的位置。请输入您的地址。`,
    UNAVAILABLE_ITEM: `抱歉，此商品已不可用。`,
    UNIT_GRAM: `{{$1: amount}}克`,
    UNIT_NUTRITION_INFO_CALORIES: `{{$1: amount}} 卡路里`,
    UNIT_NUTRITION_INFO_PROTEIN: `{{$1: amount}} 蛋白质`,
    UNIT_NUTRITION_INFO_CARBS: `{{$1: amount}} 碳水化合物`,
    UNIT_NUTRITION_INFO_FAT: `{{$1: amount}} 脂肪`,
    UNIT_NUTRITION_INFO_SUGAR: `{{$1: amount}} 糖分`,
    UP_TO_X: `最多 {{$1: number}} 个`,
    USE_COMP_CARD: `使用优待卡`,
    USE_COUPON: `使用优惠券`,
    USE_EBT_CARD: `EBT卡`,
    USE_EBT_CASH_BENEFIT: `EBT现金福利`,
    USE_EBT_FOOD_STAMP: `EBT食品券`,
    USE_GIFT_CARD: `使用礼品卡`,
    USERNAME: `用户名`,
    VALIDATION_MESSAGE_EMAIL_IS_INVALID: `电子邮件地址无效`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED: `{{$1: field name, e.g. 'email'}} 为必填项`,
    VALIDATION_MESSAGE_FIELD_IS_REQUIRED_GENERIC: `此字段为必填项`,
    VALIDATION_MESSAGE_ONLY_LETTERS_AND_NUMBERS: `请仅使用字母和数字`,
    VALIDATION_MESSAGE_ONLY_LETTERS_NUMBERS_AND_SPECIAL_CHARS: `请仅使用字母、数字、&、# 或英文句点`,
    VALIDATION_MESSAGE_PASSWORD_REQUIREMENTS: `密码长度至少为 14 个字符，且必须至少包含 1 个数字、1 个大写字母和1 个小写字母。`,
    VALIDATION_MESSAGE_PHONE_NUMBER_IS_INVALID: `电话号码无效`,
    VALIDATION_MESSAGE_POSTAL_CODE_IS_INVALID: `邮政编码应该是数字`,
    VENDOR_UNAVAILABLE_MESSAGE: `该供应商目前已停止营业。请查看营业时间，欢迎下次再来。`,
    VEHICLE_COLOR: `车辆颜色`,
    VEHICLE_MAKE: `车辆品牌`,
    VEHICLE_MODEL: `车辆型号`,
    VERIFY_ACCOUNT: `验证账户`,
    VERIFY_ACCOUNT_CTA: `验证您的账户以开始下单。`,
    VIDEO_LOAD_FAILED: `视频加载失败`,
    VIEW: `查看`,
    WE_APOLOGIZE: `对此给您带来的不便，我们深表歉意。`,
    WEIGHING_INSTRUCTIONS: `请将您的商品放在秤上`,
    WELCOME_BACK: `欢迎回来！为您精选的商品：`,
    WELCOME_BACK_WITH_NAME: `欢迎回来，{{$1: guest name}}！为您精选的商品：`,
    WELCOME_TO: `欢迎来到 {{$1: org name}}！`,
    WELCOME_TO_NO_NAME: ``,
    WHEN_WOULD_YOU_LIKE_YOUR_ORDER: `选择取餐时间`,
    WHICH_OUTPOST_FOR_YOUR_ORDER: `您希望在哪里取餐？`,
    YES: `是`,
    YOU_PREVIOUSLY_ORDERED: `您之前点过`,
    YOUR_CURRENT_LOCATION: `您当前的位置`,
    YOUR_NAME: `您的姓名`,
    YOUR_ORDER: `您的订单`,
    YOUR_SUBTOTAL: `您的小计`,
    ZOOM_TOGGLE_ON: `点击启用双指缩放`,
    ZOOM_TOGGLE_OFF: `点击禁用双指缩放`,
    ZOOM_INSTRUCTIONS: `双指缩放已启用。使用两根手指放大和缩小。`,
    STARBUCKS_COVER_1_BUTTON: `我知道我想要什么`,
    STARBUCKS_COVER_2_BUTTON: `带我逛逛`,
    STARBUCKS_COVER_2_TITLE: `体验、品鉴、学习`,
    STARBUCKS_COVER_PROMO_A: `咖啡查找器`,
    STARBUCKS_COVER_PROMO_B: `星巴克奖励`,
    STARBUCKS_EXPERIENCES_TITLE: `体验`,
    STARBUCKS_EXPERIENCES_SUBTITLE: `预订臻选体验，沉浸于咖啡的匠心、剧场感与创新之中`,
    STARBUCKS_EXPERIENCES_RESERVE_NOW: `预订今日`,
    STARBUCKS_EXPERIENCES_RESERVE_LATER: `预订稍后`,
    STARBUCKS_EXPERIENCES_BACK: `返回体验`,
    STARBUCKS_WAYFINDER_CARD_EXPERIENCE_BUTTON: `了解更多`,
    STARBUCKS_WAYFINDER_CARD_MENU_BUTTON: `前往菜单`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL_FIND: `我在哪里？`,
    STARBUCKS_WAYFINDER_KIOSK_LABEL: `您在这里`,
    STARBUCKS_WAYFINDER_BATHROOMS_LABEL: `洗手间`,
    STARBUCKS_WAYFINDER_OPEN_SEATING_LABEL: `自由座位`,
    STARBUCKS_WAYFINDER_HOTSPOTS_LABEL: `查找场所`,
    STARBUCKS_WAYFINDER_DIRECTIONS_TITLE: `用手指拖动以探索空间。`,
    STARBUCKS_WAYFINDER_DIRECTIONS_SUBTITLE: `点击高亮显示的场所以了解更多信息。`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_TITLE: `冒险精神`,
    STARBUCKS_COFFEE_FINDER_QUESTION_1_SUBTITLE: `您喜欢多有冒险精神的咖啡？`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_TITLE: `偏好口味`,
    STARBUCKS_COFFEE_FINDER_QUESTION_2_SUBTITLE: `想到您的咖啡时，哪些口味听起来最美味？`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_TITLE: `浓度`,
    STARBUCKS_COFFEE_FINDER_QUESTION_3_SUBTITLE: `您喜欢多浓的咖啡？`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_TITLE: `偏好的咖啡点法`,
    STARBUCKS_COFFEE_FINDER_QUESTION_4_SUBTITLE: `您通常喜欢如何点咖啡？`,
    STARBUCKS_COFFEE_FINDER_QUESTION_EDIT: `点击编辑`,
    STARBUCKS_COFFEE_FINDER_QUESTION_CONFIRM: `确认您的选择`,
    STARBUCKS_COFFEE_FINDER_QUESTION_RESTART: `重新开始`,
    STARBUCKS_COFFEE_FINDER_ANSWER_TITLE: `看起来您会喜欢`,
    STARBUCKS_COFFEE_FINDER_ANSWER_SUBTITLE: `只购买咖啡豆，或者我们推荐下方使用此咖啡豆的饮品：`,
    STARBUCKS_COFFEE_FINDER_ANSWER_GO_TO_MENU: `查看完整菜单`,
    STARBUCKS_COFFEE_FINDER_ANSWER_RESTART: `重新开始`,
    STARBUCKS_VIEW_WAYFINDER: `带我逛逛`,
    STARBUCKS_VIEW_COFFEE_FINDER: `缩小我的选择范围`,
    STARBUCKS_VIEW_EXPERIENCES: `查看体验`,
    'cover.session.timeout': `出现问题。请重试。`,
    'cover.reduced-height.button': `开始点餐`,
    'cover.loyalty.title': `欢迎`,
    'cover.five-guys.documents': ``,
    'cover.five-guys.allergen-nutrition': ``,
    'cover.five-guys.ingredients': ``,
    'cover.five-guys.storm-document-instructions': ``,
    'cover.loyalty.login': `使用会员账户登录`,
    'cover.loyalty.guest': `以访客身份继续`,
    'guest-identifier.button.quit': `退出`,
    'guest-identifier.button.skip': `跳过`,
    'guest-identifier.button.back': `返回`,
    'guest-identifier.button.next': `继续`,
    'guest-identifier.button.submit.cover': `继续`,
    'guest-identifier.button.submit.edit': `继续`,
    'guest-identifier.button.submit.checkout': `继续`,
    'guest-identifier.phone.tos.button-back': `返回`,
    'guest-identifier.phone.tos.title': `服务条款`,
    'guest-identifier.phone.tos.link': `电话号码服务条款`,
    'guest-identifier.phone.title': ``,
    'guest-identifier.table.instructions.table-number': ``,
    'guest-identifier.table.instructions.tracker-number': ``,
    'guest-identifier.name.loyalty-title': `使用您的会员账户登录`,
    'guest-identifier.name.loyalty-button': `使用会员账户登录`,
    'guest-identifier.name.loyalty-separator': `或`,
    'guest-identifier.name.loyalty-error-title': `哎呀！未找到姓名`,
    'guest-identifier.name.loyalty-error-description': `抱歉，未找到与此账户关联的姓名。请在下方输入您的姓名`,
    'inactivity-timer.button.continue': `是，我需要更多时间`,
    'inactivity-timer.button.exit': `不，我已完成`,
    'item-card.add.with-quantity': `添加 ({{$1: quantity}})`,
    'image.scan.default.alt': `扫描您的条形码或二维码`,
    'loyalty.view_coupons': `查看优惠券`,
    'loyalty.add_coupons': `添加优惠券`,
    'loyalty.label.manual_redemption': `兑换码`,
    'loyalty.label.manual_redemption_instructions': `输入您的兑换码以兑换奖励`,
    'loyalty.label.welcome.new-user': `您好，{{$1: user}}！您已拥有会员账户`,
    'loyalty.reward_label.payment_unapplied': `将支付应用至存档卡`,
    'loyalty.reward_label.redeemable_unredeemed': `使用 {{$1: points}} 积分兑换`,
    'loyalty.reward_label.payment_at_checkout': `支付可在结账时应用`,
    'loyalty.reward_group_label.payment': `支付奖励`,
    'loyalty.rewards.payment-reward.name': `使用余额支付`,
    'loyalty.rewards.payment-reward.name-with-amount': `使用余额支付（{{$1: amount}}）`,
    'loyalty.rewards.payment-reward.description': `您的当前余额`,
    'loyalty.rewards.card-on-file-payment.description': `将向您的存档卡收取此款项。`,
    'loyalty.redemption_auth.back_to_rewards': `返回奖励`,
    'loyalty.redemption_auth.subtitle': `扫描您的兑换条形码以兑换奖励`,
    'loyalty.redemption_auth.submit': `兑换奖励`,
    'loyalty.signup.header': ``,
    'loyalty.signup.email-already-exists': ``,
    'loyalty.signup.email-and-sms-consent': ``,
    'loyalty.signup.enter-your-email-address': ``,
    'loyalty.signup.enter-your-name': `输入您的姓名`,
    'loyalty.signup.enter-your-phone-number': `(555) 555-5555`,
    'loyalty.signup.consent-required': `请接受条款和条件以继续。`,
    'loyalty.checkout-signup.header': `最后机会注册并赚取此订单的奖励！`,
    'loyalty.checkout-signup.skip': `跳过并继续结账`,
    'loyalty.checkout-signup.success.new-account.title': `新账户已创建`,
    'loyalty.checkout-signup.success.new-account.description': `感谢加入，您将在此订单中赚取奖励！`,
    'loyalty.checkout-signup.success.existing-account.title': `账户已存在`,
    'loyalty.checkout-signup.success.existing-account.description': `您之前已使用此号码注册。您现已登录。`,
    'loyalty.checkout-signup.error.title': `创建账户时出错`,
    'loyalty.checkout-signup.error.description': `创建账户过程中出现问题`,
    'loyalty.checkout-signup.error.skip': `跳过并继续结账`,
    'loyalty.checkout-signup.error.try-again': `重试`,
    'menu.item.reset': `重置商品`,
    'menu.mod-group.quick-select': `快速选择`,
    'menu.mod-group.quick-select-active': `已选择`,
    'menu.mod-group.quick-select-clear': ``,
    'menu.page.scanner.initial.title': `扫描商品开始点餐`,
    'menu.page.scanner.scanned.title': `购物车商品`,
    'menu.scanned-item-added-dialog.button.go-to-scanner-page': `查看已扫描商品`,
    'order-history.button.add-to-order': `添加可用商品 ({{$1: number}})`,
    'order-history.title': `订单历史`,
    'order-history.subtitle': `您所有以前的订单都将显示在此处。与商品互动以查看或将其添加到当前订单。您可以一键添加订单中的所有商品。`,
    'order-history.next-page': `下一页`,
    'order-history.previous-page': `上一页`,
    'order-history.screen.close': `关闭`,
    'order-history.screen.error.title': `出现问题`,
    'order-history.screen.error.subtitle': `加载订单历史失败，请稍后重试。`,
    'order-history.screen.error.button.back': `返回`,
    'order-history.screen.error.button.retry': `重试`,
    'order-history.screen.no-orders': `未找到以前的订单。下单后，回到此处查看。`,
    'order-history.screen.order-has-quick-add-uneligible-items': `此订单中的部分商品无法快速重新下单。请逐个点击添加这些商品。`,
    'order-history.section.button.view-all': `查看更多我的订单`,
    'order-history.topbar.button.back': `返回`,
    'loyalty.unapplicable_rewards_warning_title': `不适用的奖励`,
    'loyalty.unapplicable_rewards_warning_description': `要兑换所选奖励，请将适用的商品添加到您的购物车。奖励和折扣将在结账时应用。`,
    'loyalty.unapplicable_rewards_warning_confirm': `应用`,
    'loyalty.discard_reward_changes.title': ``,
    'loyalty.discard_reward_changes.description': ``,
    'loyalty.discard_reward_changes.keep_editing': ``,
    'loyalty.discard_reward_changes.discard': ``,
    'loyalty.rewards.terms_button_label': ``,
    'loyalty.rewards.terms_dialog.apply': ``,
    'loyalty.rewards.terms_dialog.remove': ``,
    'loyalty.rewards.terms_dialog.back': ``,
    'loyalty.reward_ineligible.title': ``,
    'loyalty.reward_ineligible.title_generic': ``,
    'loyalty.reward_ineligible.title_plural': ``,
    'loyalty.reward_ineligible.description': ``,
    'loyalty.reward_ineligible.description_plural': ``,
    'loyalty.reward_ineligible.back_to_menu': ``,
    'loyalty.reward_ineligible.continue': ``,
    'loyalty.reward_ineligible.continue_plural': ``,
    'loyalty.auth_method.manual_redemption': `手动输入`,
    'loyalty.button.menu.authed': `奖励`,
    'loyalty.button.menu.unauthed': `奖励`,
    'loyalty.button.checkout.authed': `奖励`,
    'loyalty.button.checkout.unauthed': `奖励`,
    'loyalty.error.reward_failed_to_apply': `应用奖励失败。请重试。`,
    'loyalty.login.pin.label': ``,
    'loyalty.login.pin.error-required': ``,
    'loyalty.login-options.button.skip.menu': `跳过并继续前往菜单`,
    'loyalty.login-options.button.skip.checkout': `跳过并继续前往支付`,
    'loyalty.login-options.button.skip.dining-option-collection': `跳过并继续结账`,
    'loyalty.login-options.title': `选择登录方式或以访客身份继续`,
    'loyalty.login-options.subtitle': `您可以随时稍后登录`,
    'loyalty.login-options.signup.link': `没有账户？注册`,
    'loyalty.login-options.barcode.title': `扫描条形码`,
    'loyalty.login-options.barcode.subtitle': `扫描您的条形码登录`,
    'loyalty.login-options.email-phone-number.title': `电子邮件和电话号码`,
    'loyalty.login-options.email-phone-number.subtitle': `输入您的电子邮件和电话号码以登录`,
    'loyalty.login-options.email-password.title': `电子邮件和密码`,
    'loyalty.login-options.email-password.subtitle': `输入您的电子邮件和密码以登录`,
    'loyalty.login-options.username-password.title': `用户名和密码`,
    'loyalty.login-options.username-password.subtitle': `输入您的用户名和密码以登录`,
    'loyalty.login-options.phone-number.placeholder': `(555) 555-5555`,
    'loyalty.login-options.phone-number.title': `电话号码`,
    'loyalty.login-options.phone-number.subtitle': `输入您的电话号码以登录`,
    'loyalty.login-options.card-number.title': `卡号`,
    'loyalty.login-options.card-number.subtitle': `输入您的卡号以登录`,
    'loyalty.login-options.email.title': `电子邮件`,
    'loyalty.login-options.email.subtitle': `输入您的电子邮件以登录`,
    'loyalty.login-options.or': `或`,
    'loyalty.login-options.popup.close': `关闭`,
    'loyalty.error.or': `或`,
    'loyalty.login-error.saved-form': `您提交的信息：`,
    'loyalty.login-error.try-again.button': `重试`,
    'loyalty.otp.enter-code.title': `输入我们发送给您的验证码`,
    'loyalty.otp.sent-to.email': `我们已将验证码通过电子邮件发送至 {{$1: masked email}}`,
    'loyalty.otp.sent-to.sms': `我们已将验证码通过短信发送至 {{$1: masked phone number}}`,
    'loyalty.otp.verify': `验证`,
    'loyalty.otp.resend': `重新发送验证码`,
    'loyalty.otp.code.error.invalid': `验证码错误。请重试。`,
    'loyalty.otp.send-error.message': `我们无法为该信息精确匹配到唯一账户。请核对后重试。`,
    'loyalty.login.fallback.phone-number.button': `改用电话号码`,
    'loyalty.login.fallback.barcode.button': `改为扫描条形码或二维码`,
    'loyalty.login.fallback.card-number.button': `改用卡号`,
    'loyalty.login.fallback.email.button': `改用电子邮件`,
    'loyalty.login.fallback.email-phone-number.button': `改用电子邮件和电话号码`,
    'loyalty.login.fallback.email-password.button': `改用电子邮件和密码`,
    'loyalty.login.fallback.username-password.button': `改用用户名和密码`,
    'loyalty.login.auth-method.phone-number.title': `电话号码`,
    'loyalty.login.auth-method.barcode.title': `扫描条形码或二维码`,
    'loyalty.login.auth-method.card-number.title': `卡号`,
    'loyalty.login.auth-method.email.title': `电子邮件`,
    'loyalty.login.auth-method.email-phone-number.title': `电子邮件和电话号码`,
    'loyalty.login.auth-method.email-password.title': `电子邮件和密码`,
    'loyalty.login.auth-method.username-password.title': `用户名和密码`,
    'vitrine.error.order_validation_failed': `订单验证失败。请重试。`,
    'vitrine.error.handshake_failed': `无法连接至自助机。请联系工作人员。`,
    'vitrine.error.request_timeout': `无法完成请求。请重试。`,
    'vitrine.error.request_aborted': `无法完成请求。请重试。`,
    'vitrine.error.analytics_send_error': `无法发送分析数据。请重试。`,
    'vitrine.error.garcon_incompatible_build': `无法连接至自助机。请联系工作人员寻求帮助。`,
    'vitrine.error.loyalty-login-no-matching-user-title': `未找到您的账户`,
    'vitrine.error.loyalty-login-no-matching-user-message': `未找到与您提供的信息匹配的用户。`,
    'vitrine.error.loyalty_not_enough_points': `您的账户积分不足以兑换所选奖励。`,
    'vitrine.error.order_total_above_max': `订单总额已超过允许的最大值。请联系工作人员。`,
    'vitrine.error.empty_menu': `您选择的菜单目前为空。请尝试其他用餐选项。`,
    'maitred.error.integration_bad_config': `自助机配置似乎存在问题。请联系工作人员。`,
    'checkout.done.expo_receipt.error': `无法打印收据。请重试。`,
    'checkout.done.expo_receipt.success': `收据已发送！请寻求团队成员帮助。`,
    'checkout.done.print-receipt.out-of-paper': `打印机缺纸。请寻求团队成员帮助以获取您的收据。`,
    'refunder.viewing-results.button.cancel': `取消`,
    'refunder.viewing-results.button.refund-all': `全部退款`,
    'refunder.viewing-results.button.view-transaction': `查看交易`,
    'refunder.viewing-results.button.done': `完成`,
    'refunder.viewing-results.button.back': `返回`,
    'refunder.viewing-results.button.search': `搜索订单`,
    'refunder.viewing-results.refund-order.error-print-receipt': `订单已成功退款，但我们无法打印收据。请重试打印。`,
    'refunder.viewing-results.refund-order.success': `订单已成功退款。`,
    'refunder.viewing-results.refund-order.error': `退款失败。请重试。`,
    'refunder.viewing-results.order.refunded': `订单已退款`,
    'refunder.viewing-results.order.total': `订单总计`,
    'refunder.search-form.button.back': `返回`,
    'refunder.search-form.button.search': `搜索`,
    'refunder.viewing-order.title': `订单 #{{$1: order number}} 的所有交易`,
    'refunder.viewing-order.subtitle': `请选择您要退款的交易。`,
    'refunder.viewing-order.button.cancel': `取消`,
    'refunder.viewing-order.button.refund': `退款`,
    'refunder.viewing-order.button.refund-partial': `部分退款`,
    'refunder.viewing-order.button.retry': `重试`,
    'refunder.viewing-order.button.done': `完成`,
    'refunder.viewing-order.button.back': `返回`,
    'refunder.viewing-order.refund-transaction.error': `交易退款失败。请重试。`,
    'refunder.viewing-order.refund-transaction.success': `交易退款成功。`,
    'refunder.viewing-order.refund-transaction.error-print-receipt': `交易已成功退款，但我们无法打印收据。请重试打印。`,
    'refunder.viewing-order.transaction.total': `总计`,
    'refunder.viewing-order.transaction.refunded': `已退款`,
    'refunder.viewing-order.error.title': `错误`,
    'refunder.viewing-order.error.message': `加载订单失败。请重试。`,
    'refunder.viewing-order.error.button.retry': `重试`,
    'refunder.viewing-order.error.button.back': `返回`,
    'refunder.partial-transaction-refund.error.amount-too-high': `金额过高。`,
    'refunder.partial-transaction-refund.error.amount-too-low': `金额过低。`,
    'refunder.partial-transaction-refund.error.amount-invalid': `金额无效。`,
    'refunder.partial-transaction-refund.error.amount-required': `金额为必填项。`,
    'refunder.partial-transaction-refund.error': `处理退款时出现问题。请重试。`,
    'refunder.partial-transaction-refund.button.submit': `提交部分退款`,
    'refunder.partial-transaction-refund.button.back': `返回`,
    'refunder.partial-transaction-refund.title': `部分退款交易`,
    'refunder.partial-transaction-refund.hint': `请输入您要退款的金额。最高金额为 {{$1: amount}}`,
    'refunder.partial-transaction-refund.label': `金额`,
    'refunder.partial-transaction-refund.placeholder': `0.00`,
    'checkout.cart.alcohol-verification.age-requirement': `21+`,
    'checkout.cart.alcohol-requires-food.notice': ``,
    'checkout.cart.alcohol-requires-food.title': ``,
    'checkout.cart.alcohol-requires-food.description': ``,
    'checkout.cart.group-ordering.actions.change-recipient': `编辑接收人`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.title': `将商品分配给`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.cancel': `取消`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.add-new': `添加新项目`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.reassign': `重新分配`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.who-is-this-for': `这个商品是谁的？`,
    'checkout.cart.guest-ordering.recipient-assignment-dialog.assign-to-guest': `分配给此客人`,
    'checkout.cart.starbucks-stars': `{{$1: amount}} ★ 商品`,
    'checkout.cart.mod-group-heading': `{{$1: mod group name}}:`,
    'menu.nav.starbucks.menu': `主菜单`,
    'menu.nav.starbucks.experiences': `体验`,
    'menu.nav.starbucks.wayfinder': `导览`,
    'menu.secret-menu.access-code.title': `输入访问码`,
    'menu.secret-menu.access-code.button.back': `返回`,
    'menu.secret-menu.access-code.button.submit': `提交`,
    'menu.secret-menu.access-code.error': `访问码无效`,
    'menu.secret-menu.access-code.success': `访问码已接受`,
    'menu.toast.added-to-cart': `已添加到购物车`,
    'menu.toast.combo-savings': `套餐优惠！`,
    'menu.toast.discount-applied': `折扣已应用！`,
    'menu.exit-verification.title': `需要经理验证`,
    'menu.exit-verification.description': `退出需要员工访问码。请寻求团队成员帮助。`,
    'menu-item.starbucks-stars': `{{$1: amount}} ★`,
    'menu-item.product-information.title': ``,
    'menu-item.product-information.open': ``,
    'menu-item.product-information.tab.product-info': ``,
    'menu-item.product-information.tab.nutrition': ``,
    'menu-item.product-information.tab.allergens': ``,
    'menu-item.product-information.nutrition.option': ``,
    'menu-item.product-information.empty': ``,
    'menu-item.scale.title': `请将您的商品放在秤上。`,
    'menu-item.scale.weight': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.weighs': `重量`,
    'menu-item.scale.price-per-unit': `{{$1: price}} / {{$2: unit}}`,
    'menu-item.scale.price': `价格`,
    'menu-item.scale.instructions': `使用秤称量您的商品。如需重置，请按秤上指示的按钮。`,
    'menu-item.scale.weight-per-unit': `{{$1: weight}} {{$2: unit}}`,
    'menu-item.scale.reading-weight': `正在称重...`,
    'menu-item.scale.error-reading-weight': `读取重量时出错。请重试。`,
    'menu-item.scale.error-no-weight': `如果您希望将商品添加到订单，请先称重。`,
    'menu-item.scale.no-scale': `未检测到秤。请联系工作人员。`,
    'also-consider.title': `您可能也会喜欢...`,
    'also-consider.back-to-item': `返回商品`,
    'also-consider.add-to-order': `添加到订单`,
    'also-consider.skip-add-on': `跳过附加项`,
    'menu-item.assorted.title': `搭配您的组合`,
    'menu-item.assorted.count': `已选择 {{$1: count}}/{{$2: total}}`,
    'menu-item.row-size-mod.option.none': `无`,
    'menu-item.high-sugar-warning.description': `警告：此图标表示该商品的添加糖含量等于或高于 2,000 卡路里饮食每日推荐添加糖总限量（50 克）。长期大量食用或饮用添加糖会增加患 2 型糖尿病、体重增加和蛀牙的风险。`,
    'menu-item.high-sodium-warning.description': `警告：此图标表示该商品的钠（盐）含量高于每日推荐总限量（2,300 毫克）。高钠摄入会升高血压并增加患心脏病和中风的风险。`,
    'menu-item.group-ordering.items-for': `团体订单 - 商品属于：`,
    'menu-item.group-ordering.prompt.title': `团体点餐？`,
    'menu-item.group-ordering.prompt.description': `团体点餐选项将询问每件商品属于您一行中的哪位成员。点击"是"启用团体点餐。点击"否"继续使用此选项。`,
    'menu-item.group-ordering.prompt.button.accept': `是，团体点餐`,
    'menu-item.group-ordering.prompt.button.decline': `不，谢谢`,
    'menu-item.group-ordering.add-recipient': `添加新项目`,
    'menu-item.group-ordering.add-recipient-name.dialog.title': `添加新接收人`,
    'menu-item.group-ordering.add-recipient-name.dialog.placeholder': `输入接收人的姓名`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.submit': `分配给此客人`,
    'menu-item.group-ordering.add-recipient-name.dialog.button.cancel': `取消`,
    'menu-item.group-ordering.recipient-picker.title': `这是谁的？`,
    'menu-item.group-ordering.recipient-picker.add-new': `添加新项目`,
    'menu-item.nested-mod-groups.edit': `编辑`,
    'menu-item.nested-mod-groups.popup.done': `完成`,
    'menu-item.nested-mod-groups.popup.cancel': `取消`,
    'menu-item.nested-mod-groups.popup.back': `返回`,
    'menu-item.nested-mod-groups.popup.next': `下一步`,
    'checkout.cart.remove-item-verification.title': `需要经理验证`,
    'checkout.cart.remove-item-verification.description': `从购物车中删除此商品需要员工访问码。请寻求团队成员帮助。`,
    'checkout.cart.confirm-remove-item.title': `删除商品？`,
    'checkout.cart.confirm-remove-item.description': `确定要从购物车中删除 {{$1: item name}} 吗？`,
    'checkout.cart.confirm-remove-item.cancel': `取消`,
    'checkout.cart.confirm-remove-item.confirm': `删除`,
    'checkout.cart.pre-checkout-recommendations.title': `完善您的订单`,
    'checkout.cart.pre-checkout-recommendations.continue-button': `继续`,
    'checkout.cart.pre-checkout-recommendations.back-button': `返回`,
    'checkout.cart.item-86d.title.items': `部分商品已不可用`,
    'checkout.cart.item-86d.title.mods': `部分修改项已不可用`,
    'checkout.cart.item-86d.title.mixed': `部分商品和修改项已不可用`,
    'checkout.cart.item-86d.description.items': `以下商品已从您的购物车中移除：`,
    'checkout.cart.item-86d.description.mods': `以下修改项已从您的商品中移除：`,
    'checkout.cart.item-86d.description.mixed': `以下项目已不可用并已被移除：`,
    'checkout.cart.item-86d.entity.menu-item': `{{$1: item name}}`,
    'checkout.cart.item-86d.entity.price-option': `{{$1: item name}} — {{$2: price option name}}`,
    'checkout.cart.item-86d.entity.mod': `{{$1: mod name}}（在 {{$2: item name}} 中）`,
    'checkout.cart.item-86d.edit-item-button': `编辑`,
    'checkout.payment-options.tip.invalid-tip-amount': `抱歉，您无法添加大于订单总额的小费。请输入小于订单小计减去所有折扣后金额的小费。`,
    'checkout.payment-options.name.title': `您好，{{$1: name}}`,
    'checkout.payment-options.gift-cards.prompt.title': `选择礼品卡方式`,
    'checkout.payment-options.gift-cards.prompt.default-option': `礼品卡`,
    'checkout.payment-options.pay-with-cash-machine.label': `点击使用现金机支付`,
    'checkout.payment-options.pay-with-cash-machine.button': `现金`,
    'checkout.payment-options.donation.or': `或`,
    'checkout.payment-options.service-charge.info-message': ``,
    'checkout.payment-options.service-charge.info-label': `服务费信息`,
    'checkout.payment-options.credit-card.button.zero-balance': `下单`,
    'checkout.payment-options.inline-loyalty.view-all': `查看所有奖励`,
    'checkout.payment-options.inline-loyalty.apply': `应用奖励`,
    'checkout.payment-options.inline-loyalty.greeting': `您好，{{$1: name}}！`,
    'checkout.payment-options.inline-loyalty.star-balance': `星星余额：{{$1: stars}}★`,
    'checkout.payment-options.inline-loyalty.celebration.title': `生日快乐！`,
    'checkout.payment-options.inline-loyalty.celebration.title-with-name': `生日快乐，{{$1: name}}！`,
    'checkout.payment-options.inline-loyalty.celebration.subtitle': `享受您的礼品！`,
    'checkout.payment-options.inline-loyalty.error.title': `无法应用奖励`,
    'checkout.payment-options.inline-loyalty.error.message': `应用您的奖励时出错。请重试。`,
    'loyalty.starbucks.header.redeemable-stars': `可兑换星星`,
    'loyalty.starbucks.header.stars-expiring': `{{$1: stars}}★ 将于 {{$2: date}} 到期`,
    'loyalty.starbucks.header.stars-no-expiry': `您的星星不会到期`,
    'loyalty.starbucks.progress.next-status-by-date': `在 {{$2: date}} 前赚取 {{$1: stars}}★ 即可达到 {{$3: level}} 等级`,
    'loyalty.starbucks.progress.next-status': `赚取 {{$1: stars}}★ 即可达到 {{$2: level}} 等级`,
    'loyalty.starbucks.progress.maintain-status-by-date': `在 {{$2: date}} 前赚取 {{$1: stars}}★ 即可将您的 {{$3: level}} 等级延长一年`,
    'loyalty.starbucks.progress.maintain-status': `赚取 {{$1: stars}}★ 即可将您的 {{$2: level}} 等级延长一年`,
    'loyalty.starbucks.progress.extended': `已延长一年`,
    'loyalty.starbucks.progress.annual-earned': `年度已赚取`,
    'loyalty.starbucks.progress.status-target': `{{$1: level}} 等级`,
    'loyalty.starbucks.progress.to-extend': `以延长`,
    'loyalty.starbucks.birthday.title': `生日快乐，{{$1: name}}！`,
    'loyalty.starbucks.birthday.title-no-name': `生日快乐！`,
    'loyalty.starbucks.birthday.redeem': `兑换您的生日优惠券！`,
    'loyalty.starbucks.birthday.description': `尽享您最喜爱的饮品或点心，由我们请客。结账时兑换，或在点餐时告知您的咖啡师。`,
    'loyalty.starbucks.birthday.valid-until': `有效期至 {{$1: date}}`,
    'loyalty.starbucks.member-since': `自 {{$1: year}} 年成为会员`,
    'loyalty.starbucks.member-since.subtitle': `感谢您成为忠实的星巴克奖励会员。`,
    'checkout.paying.starbucks.title': `请立即扫描您星巴克应用上的二维码`,
    'checkout.paying.starbucks.subtitle': `请确保您的星巴克应用中已准备好 Scan to Pay 功能以完成您的订单。`,
    'checkout.paying.starbucks.cancel-button': `取消`,
    'checkout.paying.error.card-not-accepted': ``,
    'checkout.paying.error.loyalty-payment': `抱歉，我们无法处理您的支付。请重试。`,
    'checkout.paying.error.pos.print': `继续并打印收据`,
    'checkout.paying.error.table-tracker.print': `继续并打印收据`,
    'checkout.paying.error.table-tracker.title': `哎呀！我们无法获取您的取餐器。`,
    'checkout.paying.error.table-tracker.instructions': `您的订单已提交，但在派发用于追踪订单的桌位追踪器时出现错误。请继续下一步以获取您的收据。`,
    'checkout.paying.error.title': `哎呀！`,
    'checkout.paying.sending-table-tracker-request.title': `正在派发取餐器`,
    'checkout.paying.sending-table-tracker-request.subtitle': `请稍候，我们正在派发您的桌位追踪器。`,
    'checkout.paying.cash-machine.pinging.title': `正在检查现金机`,
    'checkout.paying.cash-machine.pinging.subtitle': `请稍候，我们正在检查现金机是否可用。`,
    'checkout.paying.cash-machine.awaiting.title': `现金机使用中`,
    'checkout.paying.cash-machine.awaiting.subtitle': `请等待现金机可用。`,
    'checkout.paying.cash-machine.awaiting.cancel-button': `取消`,
    'checkout.paying.cash-machine.receiving.title': `现金机就绪`,
    'checkout.paying.cash-machine.receiving.subtitle': `请将您的付款放入现金机。`,
    'checkout.paying.cash-machine.receiving.cancel-button': `取消`,
    'checkout.paying.cash-machine.receiving.cancel-refund-button': `取消并退款`,
    'checkout.paying.cash-machine.receiving.partial-button': `以其他方式支付余款`,
    'checkout.paying.cash-machine.receiving.amount': `剩余 {{$1: amount}}`,
    'checkout.paying.cash-machine.receiving.take-change-prompt': `请从现金机中取走所有纸币和硬币。`,
    'checkout.paying.cash-machine.cancelling.title': `正在取消现金机支付`,
    'checkout.paying.cash-machine.cancelling.subtitle': `请从现金机中取走所有纸币和硬币。`,
    'checkout.paying.cash-machine.cancelling.error.title': `取消现金机支付时出错`,
    'checkout.paying.cash-machine.cancelling.error.subtitle': `无法取消您的付款。请寻求团队成员帮助。`,
    'checkout.paying.cash-machine.cancelling.error.print': `继续并打印收据`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.title': `找零不足`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.subtitle': `现金机无法为您的付款找零，因此我们已退还您的付款。`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.try-again-button': `重试`,
    'checkout.paying.cash-machine.cancelling.insufficient-change.back-button': `返回`,
    'checkout.paying.cash-machine.error.message': `现金机无法处理您的支付。请重试。`,
    'checkout.done.details.guest-name': `姓名`,
    'checkout.done.details.table-number': `桌号`,
    'checkout.done.details.tracker-number': `追踪号`,
    'checkout.done.details.order-number': `订单号`,
    'checkout.done.error.table-tracker.instructions': `获取您的取餐器时出错。您的订单已成功处理。请寻求员工帮助。`,
    'checkout.done.qr-code.error': `抱歉，我们无法为您的收据生成二维码。`,
    'printer-receipt.stored-value-remaining-balance': `{{$1: label}} 剩余余额`,
    'printer-receipt.order-ready-at': ``,
    'printer-receipt.punchh-barcode-header': ``,
    'printer-receipt.refund-receipt-header': ``,
    'order-reconciler.error.dining-option-unavailable': `您选择的用餐选项已不可用。您的订单已更新为使用"{{$1: dining option name}}"。`,
    'order-reconciler.error.items-unavailable': `您订单中的部分商品已不可用。您的订单已更新以移除不可用的商品。以下商品已被移除：{{$1: item names}}`,
    'page-nav.order-history-item.title': `我的订单`,
    'page-nav.order-history-item.cta': `查看我的订单`,
    'print.error.phone-number-label': `电话号码`,
    'print.error.guest-name-label': `姓名`,
    'print.error.table-number-label': `桌号`,
    'print.error.tracker-number-label': `跟踪号`,
    'print.error.order-number-label': `订单号`,
    'debug.untranslated-locale': ``,
};
//# sourceMappingURL=strings.zh-cn.js.map